/* @generated from adl module totalinteraction.futurefit.db */

import * as ADL from './../../runtime/adl';
import * as common from './../../common';
import * as common_db from './../../common/db';
import * as sys_types from './../../sys/types';

/**
 * Extend sys.types.Pair
 */
export interface Triplet<T1, T2, T3> {
  v1: T1;
  v2: T2;
  v3: T3;
}

export function makeTriplet<T1, T2, T3>(
  input: {
    v1: T1,
    v2: T2,
    v3: T3,
  }
): Triplet<T1, T2, T3> {
  return {
    v1: input.v1,
    v2: input.v2,
    v3: input.v3,
  };
}

const Triplet_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":["T1","T2","T3"],"fields":[{"annotations":[],"serializedName":"v1","default":{"kind":"nothing"},"name":"v1","typeExpr":{"typeRef":{"kind":"typeParam","value":"T1"},"parameters":[]}},{"annotations":[],"serializedName":"v2","default":{"kind":"nothing"},"name":"v2","typeExpr":{"typeRef":{"kind":"typeParam","value":"T2"},"parameters":[]}},{"annotations":[],"serializedName":"v3","default":{"kind":"nothing"},"name":"v3","typeExpr":{"typeRef":{"kind":"typeParam","value":"T3"},"parameters":[]}}]}},"name":"Triplet","version":{"kind":"nothing"}}};

export const snTriplet: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db", name:"Triplet"};

export function texprTriplet<T1, T2, T3>(texprT1 : ADL.ATypeExpr<T1>, texprT2 : ADL.ATypeExpr<T2>, texprT3 : ADL.ATypeExpr<T3>): ADL.ATypeExpr<Triplet<T1, T2, T3>> {
  return {value : {typeRef : {kind: "reference", value : {moduleName : "totalinteraction.futurefit.db",name : "Triplet"}}, parameters : [texprT1.value, texprT2.value, texprT3.value]}};
}

export interface BrandingUrl_Default {
  kind: 'default';
}
export interface BrandingUrl_Url {
  kind: 'url';
  value: string;
}

export type BrandingUrl = BrandingUrl_Default | BrandingUrl_Url;

const BrandingUrl_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"default","default":{"kind":"nothing"},"name":"default","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"url","default":{"kind":"nothing"},"name":"url","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"BrandingUrl","version":{"kind":"nothing"}}};

export const snBrandingUrl: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db", name:"BrandingUrl"};

export function texprBrandingUrl(): ADL.ATypeExpr<BrandingUrl> {
  return {value : {typeRef : {kind: "reference", value : snBrandingUrl}, parameters : []}};
}

/**
 * AppClient - a distinct customer company
 */
export interface AppClient {
  /**
   * Textual name for presentation in the UI
   */
  name: string;
  /**
   * Domain name for this client (ie XXX in http://XXX.skillseeker.io)
   */
  domainName: string;
  /**
   * Label to be shown in the UI
   */
  logoUrl: string;
  /**
   * Background image for client login screen
   */
  loginBackgroundUrl: BrandingUrl;
  /**
   * Auth0 domain for users in this client
   * denormalized for efficiency
   */
  auth0Domain: string;
  /**
   * Auth0 client id for users in this client
   * denormalized for efficiency
   */
  auth0ClientId: string;
  /**
   * Flag to enable training recommendations to be made visible for this client
   */
  recommendationsVisible: boolean;
  /**
   * Client-level filter on displayed recommendations
   */
  providerIds: common_db.DbKey<LearningProvider>[];
  /**
   * Flag to enable automatic re-creation of user quiz on completion of quiz
   * - user can immediately run through the same quiz again
   */
  recreateUserQuizEnabled: boolean;
  /**
   * Flag to determine whether walkthroughs run at all
   */
  walkthroughsEnabled: boolean;
  /**
   * Flag to determine whether walkthroughs execute on every visit or just on first visit
   */
  skipIfAlreadySeen: boolean;
  /**
   * FF2-426 Flag to determine whether to output actual figures in reports, or percentages
   */
  debugReporting: boolean;
  /**
   * SS-610 Suppress headline ratio display
   */
  displayHeadlineRatio: boolean;
  /**
   * Display text to explain what the %ages in the Radar diagram mean
   */
  displayHeadlineText: boolean;
  /**
   * If using SSO - name of connection
   * denormalized for efficiency
   */
  connectionName: (string|null);
  /**
   * Recommendations layout - single-tab or tabbed on categories (f2f/ele/virt)
   */
  singleTabRecommendations: boolean;
  /**
   * Allow Self-Assessment (as against using Quiz)
   */
  allowSelfAssessment: boolean;
  /**
   * Only display assessments on work roles belonging to the client. Only used in admin
   */
  displayClientAssessmentsOnly: boolean;
}

export function makeAppClient(
  input: {
    name: string,
    domainName: string,
    logoUrl: string,
    loginBackgroundUrl: BrandingUrl,
    auth0Domain: string,
    auth0ClientId: string,
    recommendationsVisible: boolean,
    providerIds: common_db.DbKey<LearningProvider>[],
    recreateUserQuizEnabled: boolean,
    walkthroughsEnabled: boolean,
    skipIfAlreadySeen: boolean,
    debugReporting: boolean,
    displayHeadlineRatio?: boolean,
    displayHeadlineText?: boolean,
    connectionName: (string|null),
    singleTabRecommendations?: boolean,
    allowSelfAssessment?: boolean,
    displayClientAssessmentsOnly?: boolean,
  }
): AppClient {
  return {
    name: input.name,
    domainName: input.domainName,
    logoUrl: input.logoUrl,
    loginBackgroundUrl: input.loginBackgroundUrl,
    auth0Domain: input.auth0Domain,
    auth0ClientId: input.auth0ClientId,
    recommendationsVisible: input.recommendationsVisible,
    providerIds: input.providerIds,
    recreateUserQuizEnabled: input.recreateUserQuizEnabled,
    walkthroughsEnabled: input.walkthroughsEnabled,
    skipIfAlreadySeen: input.skipIfAlreadySeen,
    debugReporting: input.debugReporting,
    displayHeadlineRatio: input.displayHeadlineRatio === undefined ? false : input.displayHeadlineRatio,
    displayHeadlineText: input.displayHeadlineText === undefined ? true : input.displayHeadlineText,
    connectionName: input.connectionName,
    singleTabRecommendations: input.singleTabRecommendations === undefined ? false : input.singleTabRecommendations,
    allowSelfAssessment: input.allowSelfAssessment === undefined ? false : input.allowSelfAssessment,
    displayClientAssessmentsOnly: input.displayClientAssessmentsOnly === undefined ? false : input.displayClientAssessmentsOnly,
  };
}

const AppClient_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true,"uniquenessConstraints":[["name"],["domainName"]]}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"name","default":{"kind":"nothing"},"name":"name","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"domainName","default":{"kind":"nothing"},"name":"domainName","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"logoUrl","default":{"kind":"nothing"},"name":"logoUrl","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"loginBackgroundUrl","default":{"kind":"nothing"},"name":"loginBackgroundUrl","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"BrandingUrl"}},"parameters":[]}},{"annotations":[],"serializedName":"auth0Domain","default":{"kind":"nothing"},"name":"auth0Domain","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"auth0ClientId","default":{"kind":"nothing"},"name":"auth0ClientId","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"recommendationsVisible","default":{"kind":"nothing"},"name":"recommendationsVisible","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[],"serializedName":"providerIds","default":{"kind":"nothing"},"name":"providerIds","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"LearningProvider"}},"parameters":[]}]}]}},{"annotations":[],"serializedName":"recreateUserQuizEnabled","default":{"kind":"nothing"},"name":"recreateUserQuizEnabled","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[],"serializedName":"walkthroughsEnabled","default":{"kind":"nothing"},"name":"walkthroughsEnabled","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[],"serializedName":"skipIfAlreadySeen","default":{"kind":"nothing"},"name":"skipIfAlreadySeen","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[],"serializedName":"debugReporting","default":{"kind":"nothing"},"name":"debugReporting","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[],"serializedName":"displayHeadlineRatio","default":{"kind":"just","value":false},"name":"displayHeadlineRatio","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[],"serializedName":"displayHeadlineText","default":{"kind":"just","value":true},"name":"displayHeadlineText","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[],"serializedName":"connectionName","default":{"kind":"nothing"},"name":"connectionName","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"singleTabRecommendations","default":{"kind":"just","value":false},"name":"singleTabRecommendations","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[],"serializedName":"allowSelfAssessment","default":{"kind":"just","value":false},"name":"allowSelfAssessment","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[],"serializedName":"displayClientAssessmentsOnly","default":{"kind":"just","value":false},"name":"displayClientAssessmentsOnly","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}}]}},"name":"AppClient","version":{"kind":"nothing"}}};

export const snAppClient: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db", name:"AppClient"};

export function texprAppClient(): ADL.ATypeExpr<AppClient> {
  return {value : {typeRef : {kind: "reference", value : snAppClient}, parameters : []}};
}

export type AppClientId = common_db.DbKey<AppClient>;

const AppClientId_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db","decl":{"annotations":[],"type_":{"kind":"newtype_","value":{"typeParams":[],"default":{"kind":"nothing"},"typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"AppClient"}},"parameters":[]}]}}},"name":"AppClientId","version":{"kind":"nothing"}}};

export const snAppClientId: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db", name:"AppClientId"};

export function texprAppClientId(): ADL.ATypeExpr<AppClientId> {
  return {value : {typeRef : {kind: "reference", value : snAppClientId}, parameters : []}};
}

/**
 * Auth0Tenant - Model required for Auth0 Management API, as the logical place to store
 * authentication tokens in Production. (We shouldn't use manually-generated test tokens
 * in Production).
 * Also store the custom domain here, because that is not supported by the SDK as of Jan 2018 
 * (see https://github.com/auth0/auth0-java/issues/104)
 * --- [ TODO: Add FK link in AppClient ] ---
 * --- [ TODO: Test with multiple tenants & make available in Admin UI ] ---
 */
export interface Auth0Tenant {
  /**
   * Tenant name
   */
  name: string;
  /**
   * Dedicated environment - dev/test, uat, prod
   * In a multi-tenant environment we should lookup the env that is running and fetch the tenant for just that env
   */
  environment: string;
  /**
   * If there is a custom domain on the tenant, it's stored here. Otherwise the domain is the same as the API domain.
   */
  customDomain: (string|null);
  /**
   * This is the default domain to authenticate connections and for the Management API Explorer app (...auth0.com). 
   */
  auth0Domain: string;
  /**
   * The base domain (skillseeker) used to set origin, logout and callback URLs
   */
  baseDomain: string;
  /**
   * Name of API Explorer Application client - this is a Machine to Machine-type application,
   * Which is enabled on the Management API for the tenant. NB for this to work the relevant
   * grants must be explicitly enabled.
   */
  apiExplorerClientName: string;
  /**
   * IDs for the API Explorer app - need both ID and secret key
   */
  apiExplorerClientId: string;
  apiExplorerSecret: string;
  defaultLoginBackgroundUrl: string;
}

export function makeAuth0Tenant(
  input: {
    name: string,
    environment: string,
    customDomain: (string|null),
    auth0Domain: string,
    baseDomain: string,
    apiExplorerClientName: string,
    apiExplorerClientId: string,
    apiExplorerSecret: string,
    defaultLoginBackgroundUrl: string,
  }
): Auth0Tenant {
  return {
    name: input.name,
    environment: input.environment,
    customDomain: input.customDomain,
    auth0Domain: input.auth0Domain,
    baseDomain: input.baseDomain,
    apiExplorerClientName: input.apiExplorerClientName,
    apiExplorerClientId: input.apiExplorerClientId,
    apiExplorerSecret: input.apiExplorerSecret,
    defaultLoginBackgroundUrl: input.defaultLoginBackgroundUrl,
  };
}

const Auth0Tenant_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true,"uniquenessConstraints":[["name"]]}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"name","default":{"kind":"nothing"},"name":"name","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"environment","default":{"kind":"nothing"},"name":"environment","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"customDomain","default":{"kind":"nothing"},"name":"customDomain","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"auth0Domain","default":{"kind":"nothing"},"name":"auth0Domain","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"baseDomain","default":{"kind":"nothing"},"name":"baseDomain","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"apiExplorerClientName","default":{"kind":"nothing"},"name":"apiExplorerClientName","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"apiExplorerClientId","default":{"kind":"nothing"},"name":"apiExplorerClientId","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"apiExplorerSecret","default":{"kind":"nothing"},"name":"apiExplorerSecret","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"defaultLoginBackgroundUrl","default":{"kind":"nothing"},"name":"defaultLoginBackgroundUrl","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"Auth0Tenant","version":{"kind":"nothing"}}};

export const snAuth0Tenant: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db", name:"Auth0Tenant"};

export function texprAuth0Tenant(): ADL.ATypeExpr<Auth0Tenant> {
  return {value : {typeRef : {kind: "reference", value : snAuth0Tenant}, parameters : []}};
}

export interface Auth0SamlConnection {
  /**
   * Domain name (= Auth0Tenant Domain Name, not Custom Domain name) - used in 
   * IdP ACS URL https://[domain-name]/login/callback?[connection-name]
   */
  domainName: string;
  /**
   * Connection name - used in IdP ACS URL and in IdP Entity ID urn:auth0:[tenant-name]:[connection-name]
   */
  name: string;
  /**
   * X509 Certificate (PEM format)
   */
  idpX509Certificate: string;
  /**
   * Start URL at IdP if specified
   */
  idpStarturl: (string|null);
  /**
   * Signed Response to Start URL if specified
   */
  idpSignedResponse: boolean;
  /**
   * Name ID format - list as available in Google Workspace
   */
  idpNameidFormat: SamlNameidFormat;
  /**
   * Default name ID field if format = UNSPECIFIED. Not sure how IdP-specific this is
   * so leaving to free-text field at the moment (eg. "Primary email"). Google Workspace offers
   * First name and Last name as options, but this has no direct effect on the Auth0 settings
   */
  idpNameid: string;
  /**
   * Mappings for SAML attributes - set at both ends
   * These can be "name" -> ["value1", "value2", ... ] but leave to simple strings for now
   */
  idpSamlAttributeMap: sys_types.Map<string, string>;
  /**
   * Mappings for SAML attributes - set at both ends
   * These can be "name" -> ["value1", "value2", ... ] but leave to simple strings for now
   * eg. "email": "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress"
   */
  auth0SamlAttributeMap: sys_types.Map<string, string>;
  /**
   * Sign-in URL as set by IdP and saved in Auth0 connection, eg https://accounts.google.com/o/saml2/idp?idpid=...
   */
  auth0Signinurl: string;
  /**
   * Set Enable Sign Out to ON => signing out of skillseeker will sign you out of your entire SSO session
   */
  enableAuth0Signout: boolean;
  /**
   * Setting this to ON requires a bit more setup (algorithm, protocol binding, etc) - not setting here
   */
  auth0SignRequest: boolean;
  /**
   * Leave to default/unspecified
   */
  auth0UseridAttribute: (string|null);
  /**
   * Not sure what this does
   */
  auth0SyncAttributes: boolean;
}

export function makeAuth0SamlConnection(
  input: {
    domainName: string,
    name: string,
    idpX509Certificate: string,
    idpStarturl: (string|null),
    idpSignedResponse: boolean,
    idpNameidFormat: SamlNameidFormat,
    idpNameid: string,
    idpSamlAttributeMap: sys_types.Map<string, string>,
    auth0SamlAttributeMap: sys_types.Map<string, string>,
    auth0Signinurl: string,
    enableAuth0Signout?: boolean,
    auth0SignRequest?: boolean,
    auth0UseridAttribute: (string|null),
    auth0SyncAttributes?: boolean,
  }
): Auth0SamlConnection {
  return {
    domainName: input.domainName,
    name: input.name,
    idpX509Certificate: input.idpX509Certificate,
    idpStarturl: input.idpStarturl,
    idpSignedResponse: input.idpSignedResponse,
    idpNameidFormat: input.idpNameidFormat,
    idpNameid: input.idpNameid,
    idpSamlAttributeMap: input.idpSamlAttributeMap,
    auth0SamlAttributeMap: input.auth0SamlAttributeMap,
    auth0Signinurl: input.auth0Signinurl,
    enableAuth0Signout: input.enableAuth0Signout === undefined ? false : input.enableAuth0Signout,
    auth0SignRequest: input.auth0SignRequest === undefined ? false : input.auth0SignRequest,
    auth0UseridAttribute: input.auth0UseridAttribute,
    auth0SyncAttributes: input.auth0SyncAttributes === undefined ? true : input.auth0SyncAttributes,
  };
}

const Auth0SamlConnection_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true,"uniquenessConstraints":[["name"]]}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"domainName","default":{"kind":"nothing"},"name":"domainName","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"name","default":{"kind":"nothing"},"name":"name","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"idpX509Certificate","default":{"kind":"nothing"},"name":"idpX509Certificate","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"idpStarturl","default":{"kind":"nothing"},"name":"idpStarturl","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"idpSignedResponse","default":{"kind":"nothing"},"name":"idpSignedResponse","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[],"serializedName":"idpNameidFormat","default":{"kind":"nothing"},"name":"idpNameidFormat","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"SamlNameidFormat"}},"parameters":[]}},{"annotations":[],"serializedName":"idpNameid","default":{"kind":"nothing"},"name":"idpNameid","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"idpSamlAttributeMap","default":{"kind":"nothing"},"name":"idpSamlAttributeMap","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"sys.types","name":"Map"}},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]},{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"auth0SamlAttributeMap","default":{"kind":"nothing"},"name":"auth0SamlAttributeMap","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"sys.types","name":"Map"}},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]},{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"auth0Signinurl","default":{"kind":"nothing"},"name":"auth0Signinurl","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"enableAuth0Signout","default":{"kind":"just","value":false},"name":"enableAuth0Signout","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[],"serializedName":"auth0SignRequest","default":{"kind":"just","value":false},"name":"auth0SignRequest","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[],"serializedName":"auth0UseridAttribute","default":{"kind":"nothing"},"name":"auth0UseridAttribute","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"auth0SyncAttributes","default":{"kind":"just","value":true},"name":"auth0SyncAttributes","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}}]}},"name":"Auth0SamlConnection","version":{"kind":"nothing"}}};

export const snAuth0SamlConnection: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db", name:"Auth0SamlConnection"};

export function texprAuth0SamlConnection(): ADL.ATypeExpr<Auth0SamlConnection> {
  return {value : {typeRef : {kind: "reference", value : snAuth0SamlConnection}, parameters : []}};
}

export enum SamlNameidFormat {
  UNSPECIFIED,
  EMAIL,
  X509_SUBJECT,
  WIN_DOMAIN_QUALIFIED,
  KERBEROS,
  ENTITY,
  PERSISTENT,
  TRANSIENT,
  ENCRYPTED,
}

const SamlNameidFormat_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"UNSPECIFIED","default":{"kind":"nothing"},"name":"UNSPECIFIED","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"EMAIL","default":{"kind":"nothing"},"name":"EMAIL","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"X509_SUBJECT","default":{"kind":"nothing"},"name":"X509_SUBJECT","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"WIN_DOMAIN_QUALIFIED","default":{"kind":"nothing"},"name":"WIN_DOMAIN_QUALIFIED","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"KERBEROS","default":{"kind":"nothing"},"name":"KERBEROS","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"ENTITY","default":{"kind":"nothing"},"name":"ENTITY","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"PERSISTENT","default":{"kind":"nothing"},"name":"PERSISTENT","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"TRANSIENT","default":{"kind":"nothing"},"name":"TRANSIENT","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"ENCRYPTED","default":{"kind":"nothing"},"name":"ENCRYPTED","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"SamlNameidFormat","version":{"kind":"nothing"}}};

export const snSamlNameidFormat: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db", name:"SamlNameidFormat"};

export function texprSamlNameidFormat(): ADL.ATypeExpr<SamlNameidFormat> {
  return {value : {typeRef : {kind: "reference", value : snSamlNameidFormat}, parameters : []}};
}

export enum LangCode {
  en,
  zh,
  ja,
  ko,
  fr,
}

const LangCode_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"en","default":{"kind":"nothing"},"name":"en","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"zh","default":{"kind":"nothing"},"name":"zh","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"ja","default":{"kind":"nothing"},"name":"ja","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"ko","default":{"kind":"nothing"},"name":"ko","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"fr","default":{"kind":"nothing"},"name":"fr","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"LangCode","version":{"kind":"nothing"}}};

export const snLangCode: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db", name:"LangCode"};

export function texprLangCode(): ADL.ATypeExpr<LangCode> {
  return {value : {typeRef : {kind: "reference", value : snLangCode}, parameters : []}};
}

/**
 * Container for internationalized text
 */
export interface Internationalized<T> {
  /**
   * English - must be present
   */
  en: T;
  /**
   * Mandarin Chinese
   */
  zh: (T|null);
  /**
   * Japanese
   */
  ja: (T|null);
  /**
   * Korean
   */
  ko: (T|null);
  /**
   * French - for testing purposes at first
   */
  fr: (T|null);
}

export function makeInternationalized<T>(
  input: {
    en: T,
    zh?: (T|null),
    ja?: (T|null),
    ko?: (T|null),
    fr?: (T|null),
  }
): Internationalized<T> {
  return {
    en: input.en,
    zh: input.zh === undefined ? null : input.zh,
    ja: input.ja === undefined ? null : input.ja,
    ko: input.ko === undefined ? null : input.ko,
    fr: input.fr === undefined ? null : input.fr,
  };
}

const Internationalized_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":["T"],"fields":[{"annotations":[],"serializedName":"en","default":{"kind":"nothing"},"name":"en","typeExpr":{"typeRef":{"kind":"typeParam","value":"T"},"parameters":[]}},{"annotations":[],"serializedName":"zh","default":{"kind":"just","value":null},"name":"zh","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"typeParam","value":"T"},"parameters":[]}]}},{"annotations":[],"serializedName":"ja","default":{"kind":"just","value":null},"name":"ja","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"typeParam","value":"T"},"parameters":[]}]}},{"annotations":[],"serializedName":"ko","default":{"kind":"just","value":null},"name":"ko","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"typeParam","value":"T"},"parameters":[]}]}},{"annotations":[],"serializedName":"fr","default":{"kind":"just","value":null},"name":"fr","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"typeParam","value":"T"},"parameters":[]}]}}]}},"name":"Internationalized","version":{"kind":"nothing"}}};

export const snInternationalized: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db", name:"Internationalized"};

export function texprInternationalized<T>(texprT : ADL.ATypeExpr<T>): ADL.ATypeExpr<Internationalized<T>> {
  return {value : {typeRef : {kind: "reference", value : {moduleName : "totalinteraction.futurefit.db",name : "Internationalized"}}, parameters : [texprT.value]}};
}

export interface I18nContent_Text {
  kind: 'text';
  value: Internationalized<string>;
}

/**
 * Generalized content primitive
 */
export type I18nContent = I18nContent_Text;

const I18nContent_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"text","default":{"kind":"nothing"},"name":"text","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"Internationalized"}},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}}]}},"name":"I18nContent","version":{"kind":"nothing"}}};

export const snI18nContent: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db", name:"I18nContent"};

export function texprI18nContent(): ADL.ATypeExpr<I18nContent> {
  return {value : {typeRef : {kind: "reference", value : snI18nContent}, parameters : []}};
}

/**
 * A Language, used to enumerate available translations in the Admin UI.
 * NB 'language' is a reserved word in PostGresSQL
 */
export interface Lang {
  /**
   * Language code (2-letter i18n code)
   */
  code: string;
  /**
   * Name of language (in the language itself)
   */
  name: string;
  /**
   * Fallback language code
   */
  fallbackLang: string;
}

export function makeLang(
  input: {
    code: string,
    name: string,
    fallbackLang?: string,
  }
): Lang {
  return {
    code: input.code,
    name: input.name,
    fallbackLang: input.fallbackLang === undefined ? "en" : input.fallbackLang,
  };
}

const Lang_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true,"uniquenessConstraints":[["code"]]}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"code","default":{"kind":"nothing"},"name":"code","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"name","default":{"kind":"nothing"},"name":"name","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"fallbackLang","default":{"kind":"just","value":"en"},"name":"fallbackLang","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"Lang","version":{"kind":"nothing"}}};

export const snLang: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db", name:"Lang"};

export function texprLang(): ADL.ATypeExpr<Lang> {
  return {value : {typeRef : {kind: "reference", value : snLang}, parameters : []}};
}

/**
 * A Licence type - one applied to each active AppClient
 */
export interface Licence {
  /**
   * Name of licence (for visibility)
   */
  name: string;
  minActiveUsers: number;
  maxActiveUsers: number;
  /**
   * Price per licence (in USD)
   */
  licencePrice: number;
}

export function makeLicence(
  input: {
    name: string,
    minActiveUsers: number,
    maxActiveUsers: number,
    licencePrice: number,
  }
): Licence {
  return {
    name: input.name,
    minActiveUsers: input.minActiveUsers,
    maxActiveUsers: input.maxActiveUsers,
    licencePrice: input.licencePrice,
  };
}

const Licence_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true,"uniquenessConstraints":[["name"]]}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"name","default":{"kind":"nothing"},"name":"name","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"minActiveUsers","default":{"kind":"nothing"},"name":"minActiveUsers","typeExpr":{"typeRef":{"kind":"primitive","value":"Int64"},"parameters":[]}},{"annotations":[],"serializedName":"maxActiveUsers","default":{"kind":"nothing"},"name":"maxActiveUsers","typeExpr":{"typeRef":{"kind":"primitive","value":"Int64"},"parameters":[]}},{"annotations":[],"serializedName":"licencePrice","default":{"kind":"nothing"},"name":"licencePrice","typeExpr":{"typeRef":{"kind":"primitive","value":"Double"},"parameters":[]}}]}},"name":"Licence","version":{"kind":"nothing"}}};

export const snLicence: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db", name:"Licence"};

export function texprLicence(): ADL.ATypeExpr<Licence> {
  return {value : {typeRef : {kind: "reference", value : snLicence}, parameters : []}};
}

export enum AppClientLicenceInactiveStatus {
  expired,
  suspended,
  deleted,
}

const AppClientLicenceInactiveStatus_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"expired","default":{"kind":"nothing"},"name":"expired","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"suspended","default":{"kind":"nothing"},"name":"suspended","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"deleted","default":{"kind":"nothing"},"name":"deleted","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"AppClientLicenceInactiveStatus","version":{"kind":"nothing"}}};

export const snAppClientLicenceInactiveStatus: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db", name:"AppClientLicenceInactiveStatus"};

export function texprAppClientLicenceInactiveStatus(): ADL.ATypeExpr<AppClientLicenceInactiveStatus> {
  return {value : {typeRef : {kind: "reference", value : snAppClientLicenceInactiveStatus}, parameters : []}};
}

export enum AppClientLicenceActiveStatus {
  active,
}

const AppClientLicenceActiveStatus_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"active","default":{"kind":"nothing"},"name":"active","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"AppClientLicenceActiveStatus","version":{"kind":"nothing"}}};

export const snAppClientLicenceActiveStatus: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db", name:"AppClientLicenceActiveStatus"};

export function texprAppClientLicenceActiveStatus(): ADL.ATypeExpr<AppClientLicenceActiveStatus> {
  return {value : {typeRef : {kind: "reference", value : snAppClientLicenceActiveStatus}, parameters : []}};
}

export interface AppClientLicenceStatusType_Active<A, _I> {
  kind: 'active';
  value: A;
}
export interface AppClientLicenceStatusType_Inactive<_A, I> {
  kind: 'inactive';
  value: I;
}

export type AppClientLicenceStatusType<A, I> = AppClientLicenceStatusType_Active<A, I> | AppClientLicenceStatusType_Inactive<A, I>;

const AppClientLicenceStatusType_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":["A","I"],"fields":[{"annotations":[],"serializedName":"active","default":{"kind":"nothing"},"name":"active","typeExpr":{"typeRef":{"kind":"typeParam","value":"A"},"parameters":[]}},{"annotations":[],"serializedName":"inactive","default":{"kind":"nothing"},"name":"inactive","typeExpr":{"typeRef":{"kind":"typeParam","value":"I"},"parameters":[]}}]}},"name":"AppClientLicenceStatusType","version":{"kind":"nothing"}}};

export const snAppClientLicenceStatusType: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db", name:"AppClientLicenceStatusType"};

export function texprAppClientLicenceStatusType<A, I>(texprA : ADL.ATypeExpr<A>, texprI : ADL.ATypeExpr<I>): ADL.ATypeExpr<AppClientLicenceStatusType<A, I>> {
  return {value : {typeRef : {kind: "reference", value : {moduleName : "totalinteraction.futurefit.db",name : "AppClientLicenceStatusType"}}, parameters : [texprA.value, texprI.value]}};
}

export type AppClientLicenceStatus = AppClientLicenceStatusType<AppClientLicenceActiveStatus, AppClientLicenceInactiveStatus>;

const AppClientLicenceStatus_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db","decl":{"annotations":[],"type_":{"kind":"type_","value":{"typeParams":[],"typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"AppClientLicenceStatusType"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"AppClientLicenceActiveStatus"}},"parameters":[]},{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"AppClientLicenceInactiveStatus"}},"parameters":[]}]}}},"name":"AppClientLicenceStatus","version":{"kind":"nothing"}}};

export const snAppClientLicenceStatus: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db", name:"AppClientLicenceStatus"};

export function texprAppClientLicenceStatus(): ADL.ATypeExpr<AppClientLicenceStatus> {
  return {value : {typeRef : {kind: "reference", value : snAppClientLicenceStatus}, parameters : []}};
}

/**
 * A Licence as given to an AppClient
 */
export interface AppClientLicence {
  appClientId: common_db.DbKey<AppClient>;
  licenceId: common_db.DbKey<Licence>;
  /**
   * Start date of licence
   */
  startDate: common.Instant;
  /**
   * End date of licence
   */
  endDate: common.Instant;
  /**
   * Number of purchased 'seats' in total
   */
  purchased: number;
  /**
   * Number of users currently allocated
   */
  allocated: number;
  /**
   * Active or inactive status
   */
  status: AppClientLicenceStatus;
}

export function makeAppClientLicence(
  input: {
    appClientId: common_db.DbKey<AppClient>,
    licenceId: common_db.DbKey<Licence>,
    startDate: common.Instant,
    endDate: common.Instant,
    purchased: number,
    allocated: number,
    status: AppClientLicenceStatus,
  }
): AppClientLicence {
  return {
    appClientId: input.appClientId,
    licenceId: input.licenceId,
    startDate: input.startDate,
    endDate: input.endDate,
    purchased: input.purchased,
    allocated: input.allocated,
    status: input.status,
  };
}

const AppClientLicence_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true,"uniquenessConstraints":[["appClientId","startDate","status"]]}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"appClientId","default":{"kind":"nothing"},"name":"appClientId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"AppClient"}},"parameters":[]}]}},{"annotations":[],"serializedName":"licenceId","default":{"kind":"nothing"},"name":"licenceId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"Licence"}},"parameters":[]}]}},{"annotations":[],"serializedName":"startDate","default":{"kind":"nothing"},"name":"startDate","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[],"serializedName":"endDate","default":{"kind":"nothing"},"name":"endDate","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[],"serializedName":"purchased","default":{"kind":"nothing"},"name":"purchased","typeExpr":{"typeRef":{"kind":"primitive","value":"Int64"},"parameters":[]}},{"annotations":[],"serializedName":"allocated","default":{"kind":"nothing"},"name":"allocated","typeExpr":{"typeRef":{"kind":"primitive","value":"Int64"},"parameters":[]}},{"annotations":[],"serializedName":"status","default":{"kind":"nothing"},"name":"status","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"AppClientLicenceStatus"}},"parameters":[]}}]}},"name":"AppClientLicence","version":{"kind":"nothing"}}};

export const snAppClientLicence: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db", name:"AppClientLicence"};

export function texprAppClientLicence(): ADL.ATypeExpr<AppClientLicence> {
  return {value : {typeRef : {kind: "reference", value : snAppClientLicence}, parameters : []}};
}

/**
 * One 'seat' allocated under the licence to enable this AppUser,
 * Once allocated reamins indefinitely, can be re-allocated without
 * loss. 
 */
export interface AppUserSeat {
  appUserId: common_db.DbKey<AppUser>;
}

export function makeAppUserSeat(
  input: {
    appUserId: common_db.DbKey<AppUser>,
  }
): AppUserSeat {
  return {
    appUserId: input.appUserId,
  };
}

const AppUserSeat_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true,"uniquenessConstraints":[["appUserId"]]}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"appUserId","default":{"kind":"nothing"},"name":"appUserId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"AppUser"}},"parameters":[]}]}}]}},"name":"AppUserSeat","version":{"kind":"nothing"}}};

export const snAppUserSeat: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db", name:"AppUserSeat"};

export function texprAppUserSeat(): ADL.ATypeExpr<AppUserSeat> {
  return {value : {typeRef : {kind: "reference", value : snAppUserSeat}, parameters : []}};
}

export enum ApplicationRole {
  super,
  admin,
  user,
}

const ApplicationRole_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"super","default":{"kind":"nothing"},"name":"super","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"admin","default":{"kind":"nothing"},"name":"admin","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"user","default":{"kind":"nothing"},"name":"user","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"ApplicationRole","version":{"kind":"nothing"}}};

export const snApplicationRole: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db", name:"ApplicationRole"};

export function texprApplicationRole(): ADL.ATypeExpr<ApplicationRole> {
  return {value : {typeRef : {kind: "reference", value : snApplicationRole}, parameters : []}};
}

/**
 * A user of the app
 * SS-579 Remove constraint and replace with index as it doesn't go far enough
 */
export interface AppUser {
  /**
   * AppUser belongs to 1 client. AppClient has many AppUsers
   */
  appClientId: common_db.DbKey<AppClient>;
  fullname: string;
  email: string;
  role: ApplicationRole;
  /**
   * Status of user
   */
  status: AppUserStatus;
  /**
   * The user this AppUser reports to (distinct from "Manager Of", which is
   * derived from UserGroupManager and means groups this user manages).
   * Nullable self-reference; resolved from the CSV upload's Manager
   * Name/Email columns, or set directly via the admin user editor.
   */
  managerId: (common_db.DbKey<AppUser>|null);
}

export function makeAppUser(
  input: {
    appClientId: common_db.DbKey<AppClient>,
    fullname: string,
    email: string,
    role: ApplicationRole,
    status: AppUserStatus,
    managerId?: (common_db.DbKey<AppUser>|null),
  }
): AppUser {
  return {
    appClientId: input.appClientId,
    fullname: input.fullname,
    email: input.email,
    role: input.role,
    status: input.status,
    managerId: input.managerId === undefined ? null : input.managerId,
  };
}

const AppUser_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"extraSql":["create unique index app_user_2_uix on app_user (app_client_id, lower(email));"],"withIdPrimaryKey":true}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"appClientId","default":{"kind":"nothing"},"name":"appClientId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"AppClient"}},"parameters":[]}]}},{"annotations":[],"serializedName":"fullname","default":{"kind":"nothing"},"name":"fullname","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"email","default":{"kind":"nothing"},"name":"email","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"role","default":{"kind":"nothing"},"name":"role","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"ApplicationRole"}},"parameters":[]}},{"annotations":[],"serializedName":"status","default":{"kind":"nothing"},"name":"status","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"AppUserStatus"}},"parameters":[]}},{"annotations":[],"serializedName":"managerId","default":{"kind":"just","value":null},"name":"managerId","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"AppUser"}},"parameters":[]}]}]}}]}},"name":"AppUser","version":{"kind":"nothing"}}};

export const snAppUser: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db", name:"AppUser"};

export function texprAppUser(): ADL.ATypeExpr<AppUser> {
  return {value : {typeRef : {kind: "reference", value : snAppUser}, parameters : []}};
}

export enum AppUserStatus {
  active,
  suspended,
  deleted,
}

const AppUserStatus_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"active","default":{"kind":"nothing"},"name":"active","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"suspended","default":{"kind":"nothing"},"name":"suspended","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"deleted","default":{"kind":"nothing"},"name":"deleted","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"AppUserStatus","version":{"kind":"nothing"}}};

export const snAppUserStatus: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db", name:"AppUserStatus"};

export function texprAppUserStatus(): ADL.ATypeExpr<AppUserStatus> {
  return {value : {typeRef : {kind: "reference", value : snAppUserStatus}, parameters : []}};
}

/**
 * A group of users in a client
 */
export interface UserGroup {
  /**
   * AppClient of the users
   */
  appClientId: common_db.DbKey<AppClient>;
  /**
   * Group name - unique within each client
   */
  name: string;
  /**
   * Global group for a specific client
   */
  isGlobal: boolean;
}

export function makeUserGroup(
  input: {
    appClientId: common_db.DbKey<AppClient>,
    name: string,
    isGlobal: boolean,
  }
): UserGroup {
  return {
    appClientId: input.appClientId,
    name: input.name,
    isGlobal: input.isGlobal,
  };
}

const UserGroup_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true,"uniquenessConstraints":[["appClientId","name"]]}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"appClientId","default":{"kind":"nothing"},"name":"appClientId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"AppClient"}},"parameters":[]}]}},{"annotations":[],"serializedName":"name","default":{"kind":"nothing"},"name":"name","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"isGlobal","default":{"kind":"nothing"},"name":"isGlobal","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}}]}},"name":"UserGroup","version":{"kind":"nothing"}}};

export const snUserGroup: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db", name:"UserGroup"};

export function texprUserGroup(): ADL.ATypeExpr<UserGroup> {
  return {value : {typeRef : {kind: "reference", value : snUserGroup}, parameters : []}};
}

/**
 * Users as members of groups - aka 'write' - members scores become the group scores
 */
export interface UserGroupMember {
  /**
   * Given AppUser
   */
  appUserId: common_db.DbKey<AppUser>;
  /**
   * is a member of this Group
   */
  userGroupId: common_db.DbKey<UserGroup>;
}

export function makeUserGroupMember(
  input: {
    appUserId: common_db.DbKey<AppUser>,
    userGroupId: common_db.DbKey<UserGroup>,
  }
): UserGroupMember {
  return {
    appUserId: input.appUserId,
    userGroupId: input.userGroupId,
  };
}

const UserGroupMember_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true,"uniquenessConstraints":[["appUserId","userGroupId"]]}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"appUserId","default":{"kind":"nothing"},"name":"appUserId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"AppUser"}},"parameters":[]}]}},{"annotations":[],"serializedName":"userGroupId","default":{"kind":"nothing"},"name":"userGroupId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"UserGroup"}},"parameters":[]}]}}]}},"name":"UserGroupMember","version":{"kind":"nothing"}}};

export const snUserGroupMember: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db", name:"UserGroupMember"};

export function texprUserGroupMember(): ADL.ATypeExpr<UserGroupMember> {
  return {value : {typeRef : {kind: "reference", value : snUserGroupMember}, parameters : []}};
}

/**
 * AppUser as a reader of groups - aka 'read' - members can view groups results
 */
export interface UserGroupViewer {
  /**
   * Given AppUser
   */
  appUserId: common_db.DbKey<AppUser>;
  /**
   * is a viewer of this UserGroup
   */
  userGroupId: common_db.DbKey<UserGroup>;
}

export function makeUserGroupViewer(
  input: {
    appUserId: common_db.DbKey<AppUser>,
    userGroupId: common_db.DbKey<UserGroup>,
  }
): UserGroupViewer {
  return {
    appUserId: input.appUserId,
    userGroupId: input.userGroupId,
  };
}

const UserGroupViewer_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true,"uniquenessConstraints":[["appUserId","userGroupId"]]}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"appUserId","default":{"kind":"nothing"},"name":"appUserId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"AppUser"}},"parameters":[]}]}},{"annotations":[],"serializedName":"userGroupId","default":{"kind":"nothing"},"name":"userGroupId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"UserGroup"}},"parameters":[]}]}}]}},"name":"UserGroupViewer","version":{"kind":"nothing"}}};

export const snUserGroupViewer: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db", name:"UserGroupViewer"};

export function texprUserGroupViewer(): ADL.ATypeExpr<UserGroupViewer> {
  return {value : {typeRef : {kind: "reference", value : snUserGroupViewer}, parameters : []}};
}

/**
 * AppUser as managers of groups - aka 'admin'
 */
export interface UserGroupManager {
  /**
   * Given AppUser
   */
  appUserId: common_db.DbKey<AppUser>;
  /**
   * is a manager of this UserGroup
   */
  userGroupId: common_db.DbKey<UserGroup>;
}

export function makeUserGroupManager(
  input: {
    appUserId: common_db.DbKey<AppUser>,
    userGroupId: common_db.DbKey<UserGroup>,
  }
): UserGroupManager {
  return {
    appUserId: input.appUserId,
    userGroupId: input.userGroupId,
  };
}

const UserGroupManager_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true,"uniquenessConstraints":[["appUserId","userGroupId"]]}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"appUserId","default":{"kind":"nothing"},"name":"appUserId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"AppUser"}},"parameters":[]}]}},{"annotations":[],"serializedName":"userGroupId","default":{"kind":"nothing"},"name":"userGroupId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"UserGroup"}},"parameters":[]}]}}]}},"name":"UserGroupManager","version":{"kind":"nothing"}}};

export const snUserGroupManager: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db", name:"UserGroupManager"};

export function texprUserGroupManager(): ADL.ATypeExpr<UserGroupManager> {
  return {value : {typeRef : {kind: "reference", value : snUserGroupManager}, parameters : []}};
}

/**
 * Index of an answer in Question Vector<AnswerItem>
 */
export type AnswerIndex = number;

const AnswerIndex_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db","decl":{"annotations":[],"type_":{"kind":"type_","value":{"typeParams":[],"typeExpr":{"typeRef":{"kind":"primitive","value":"Int64"},"parameters":[]}}},"name":"AnswerIndex","version":{"kind":"nothing"}}};

export const snAnswerIndex: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db", name:"AnswerIndex"};

export function texprAnswerIndex(): ADL.ATypeExpr<AnswerIndex> {
  return {value : {typeRef : {kind: "reference", value : snAnswerIndex}, parameters : []}};
}

/**
 * Calculate scores and levels in integers.
 */
export type Score = number;

const Score_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db","decl":{"annotations":[],"type_":{"kind":"type_","value":{"typeParams":[],"typeExpr":{"typeRef":{"kind":"primitive","value":"Int64"},"parameters":[]}}},"name":"Score","version":{"kind":"nothing"}}};

export const snScore: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db", name:"Score"};

export function texprScore(): ADL.ATypeExpr<Score> {
  return {value : {typeRef : {kind: "reference", value : snScore}, parameters : []}};
}

export interface AnswerVariant_SingleResponse<S, _M, _O, _A> {
  kind: 'singleResponse';
  value: S;
}
export interface AnswerVariant_MultiResponse<_S, M, _O, _A> {
  kind: 'multiResponse';
  value: M;
}
export interface AnswerVariant_OrderedResponse<_S, _M, O, _A> {
  kind: 'orderedResponse';
  value: O;
}
export interface AnswerVariant_Submitted<_S, _M, _O, _A> {
  kind: 'submitted';
}
export interface AnswerVariant_Embedded<_S, _M, _O, _A> {
  kind: 'embedded';
}
export interface AnswerVariant_SelfAssessmentResponse<_S, _M, _O, _A> {
  kind: 'selfAssessmentResponse';
}

/**
 * A union type that associates different
 * data types with each variety of answer.
 */
export type AnswerVariant<S, M, O, _A> = AnswerVariant_SingleResponse<S, M, O, _A> | AnswerVariant_MultiResponse<S, M, O, _A> | AnswerVariant_OrderedResponse<S, M, O, _A> | AnswerVariant_Submitted<S, M, O, _A> | AnswerVariant_Embedded<S, M, O, _A> | AnswerVariant_SelfAssessmentResponse<S, M, O, _A>;

const AnswerVariant_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":["S","M","O","A"],"fields":[{"annotations":[],"serializedName":"singleResponse","default":{"kind":"nothing"},"name":"singleResponse","typeExpr":{"typeRef":{"kind":"typeParam","value":"S"},"parameters":[]}},{"annotations":[],"serializedName":"multiResponse","default":{"kind":"nothing"},"name":"multiResponse","typeExpr":{"typeRef":{"kind":"typeParam","value":"M"},"parameters":[]}},{"annotations":[],"serializedName":"orderedResponse","default":{"kind":"nothing"},"name":"orderedResponse","typeExpr":{"typeRef":{"kind":"typeParam","value":"O"},"parameters":[]}},{"annotations":[],"serializedName":"submitted","default":{"kind":"nothing"},"name":"submitted","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"embedded","default":{"kind":"nothing"},"name":"embedded","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"selfAssessmentResponse","default":{"kind":"nothing"},"name":"selfAssessmentResponse","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"AnswerVariant","version":{"kind":"nothing"}}};

export const snAnswerVariant: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db", name:"AnswerVariant"};

export function texprAnswerVariant<S, M, O, A>(texprS : ADL.ATypeExpr<S>, texprM : ADL.ATypeExpr<M>, texprO : ADL.ATypeExpr<O>, texprA : ADL.ATypeExpr<A>): ADL.ATypeExpr<AnswerVariant<S, M, O, A>> {
  return {value : {typeRef : {kind: "reference", value : {moduleName : "totalinteraction.futurefit.db",name : "AnswerVariant"}}, parameters : [texprS.value, texprM.value, texprO.value, texprA.value]}};
}

/**
 * Methods for describing the set of scores for answers (referring to responses by index)
 */
export type AnswerScores = AnswerVariant<SingleResponse, MultiResponse, OrderedResponse, SelfAssessmentResponse>;

const AnswerScores_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db","decl":{"annotations":[],"type_":{"kind":"type_","value":{"typeParams":[],"typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"AnswerVariant"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"SingleResponse"}},"parameters":[]},{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"MultiResponse"}},"parameters":[]},{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"OrderedResponse"}},"parameters":[]},{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"SelfAssessmentResponse"}},"parameters":[]}]}}},"name":"AnswerScores","version":{"kind":"nothing"}}};

export const snAnswerScores: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db", name:"AnswerScores"};

export function texprAnswerScores(): ADL.ATypeExpr<AnswerScores> {
  return {value : {typeRef : {kind: "reference", value : snAnswerScores}, parameters : []}};
}

/**
 * Single response answers:
 */
export interface SingleResponse {
  /**
   * Each AnswerIndex provides a given score
   */
  scores: sys_types.Map<AnswerIndex, Score>;
  /**
   * default score used for answers not mapped above.
   */
  defaultScore: Score;
}

export function makeSingleResponse(
  input: {
    scores: sys_types.Map<AnswerIndex, Score>,
    defaultScore?: Score,
  }
): SingleResponse {
  return {
    scores: input.scores,
    defaultScore: input.defaultScore === undefined ? 33 : input.defaultScore,
  };
}

const SingleResponse_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"scores","default":{"kind":"nothing"},"name":"scores","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"sys.types","name":"Map"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"AnswerIndex"}},"parameters":[]},{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"Score"}},"parameters":[]}]}},{"annotations":[],"serializedName":"defaultScore","default":{"kind":"just","value":33},"name":"defaultScore","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"Score"}},"parameters":[]}}]}},"name":"SingleResponse","version":{"kind":"nothing"}}};

export const snSingleResponse: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db", name:"SingleResponse"};

export function texprSingleResponse(): ADL.ATypeExpr<SingleResponse> {
  return {value : {typeRef : {kind: "reference", value : snSingleResponse}, parameters : []}};
}

/**
 * Multi response answers:
 */
export interface MultiResponse {
  /**
   * Each AnswerIndex provides a given score
   */
  scores: sys_types.Map<AnswerIndex, Score>;
}

export function makeMultiResponse(
  input: {
    scores: sys_types.Map<AnswerIndex, Score>,
  }
): MultiResponse {
  return {
    scores: input.scores,
  };
}

const MultiResponse_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"scores","default":{"kind":"nothing"},"name":"scores","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"sys.types","name":"Map"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"AnswerIndex"}},"parameters":[]},{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"Score"}},"parameters":[]}]}}]}},"name":"MultiResponse","version":{"kind":"nothing"}}};

export const snMultiResponse: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db", name:"MultiResponse"};

export function texprMultiResponse(): ADL.ATypeExpr<MultiResponse> {
  return {value : {typeRef : {kind: "reference", value : snMultiResponse}, parameters : []}};
}

/**
 * Ordered response answers:  Each Permutation of AnswerIndex provides a score
 */
export interface OrderedResponse {
  answerPermsScores: sys_types.Map<AnswerIndex[], Score>;
  /**
   * default score used for answers not mapped above.
   */
  defaultScore: Score;
}

export function makeOrderedResponse(
  input: {
    answerPermsScores: sys_types.Map<AnswerIndex[], Score>,
    defaultScore: Score,
  }
): OrderedResponse {
  return {
    answerPermsScores: input.answerPermsScores,
    defaultScore: input.defaultScore,
  };
}

const OrderedResponse_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"answerPermsScores","default":{"kind":"nothing"},"name":"answerPermsScores","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"sys.types","name":"Map"}},"parameters":[{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"AnswerIndex"}},"parameters":[]}]},{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"Score"}},"parameters":[]}]}},{"annotations":[],"serializedName":"defaultScore","default":{"kind":"nothing"},"name":"defaultScore","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"Score"}},"parameters":[]}}]}},"name":"OrderedResponse","version":{"kind":"nothing"}}};

export const snOrderedResponse: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db", name:"OrderedResponse"};

export function texprOrderedResponse(): ADL.ATypeExpr<OrderedResponse> {
  return {value : {typeRef : {kind: "reference", value : snOrderedResponse}, parameters : []}};
}

/**
 * Self assessment response. 
 */
export interface SelfAssessmentResponse {
  actual: Score;
}

export function makeSelfAssessmentResponse(
  input: {
    actual: Score,
  }
): SelfAssessmentResponse {
  return {
    actual: input.actual,
  };
}

const SelfAssessmentResponse_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"actual","default":{"kind":"nothing"},"name":"actual","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"Score"}},"parameters":[]}}]}},"name":"SelfAssessmentResponse","version":{"kind":"nothing"}}};

export const snSelfAssessmentResponse: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db", name:"SelfAssessmentResponse"};

export function texprSelfAssessmentResponse(): ADL.ATypeExpr<SelfAssessmentResponse> {
  return {value : {typeRef : {kind: "reference", value : snSelfAssessmentResponse}, parameters : []}};
}

/**
 * The value given as an answer. NB Won't put this into the Question struct
 * (yet) - unless we can't get around the issue of querying QuizQuestion for
 * the next question.
 */
export type AnswerResponse = AnswerVariant<AnswerIndex, sys_types.Set<AnswerIndex>, AnswerIndex[], Score>;

const AnswerResponse_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db","decl":{"annotations":[],"type_":{"kind":"type_","value":{"typeParams":[],"typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"AnswerVariant"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"AnswerIndex"}},"parameters":[]},{"typeRef":{"kind":"reference","value":{"moduleName":"sys.types","name":"Set"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"AnswerIndex"}},"parameters":[]}]},{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"AnswerIndex"}},"parameters":[]}]},{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"Score"}},"parameters":[]}]}}},"name":"AnswerResponse","version":{"kind":"nothing"}}};

export const snAnswerResponse: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db", name:"AnswerResponse"};

export function texprAnswerResponse(): ADL.ATypeExpr<AnswerResponse> {
  return {value : {typeRef : {kind: "reference", value : snAnswerResponse}, parameters : []}};
}

export interface QuestionCategory_Skill {
  kind: 'skill';
}
export interface QuestionCategory_Introduction {
  kind: 'introduction';
  value: QuestionSubCategory;
}
export interface QuestionCategory_Conclusion {
  kind: 'conclusion';
  value: QuestionSubCategory;
}

export type QuestionCategory = QuestionCategory_Skill | QuestionCategory_Introduction | QuestionCategory_Conclusion;

const QuestionCategory_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"skill","default":{"kind":"nothing"},"name":"skill","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"introduction","default":{"kind":"nothing"},"name":"introduction","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"QuestionSubCategory"}},"parameters":[]}},{"annotations":[],"serializedName":"conclusion","default":{"kind":"nothing"},"name":"conclusion","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"QuestionSubCategory"}},"parameters":[]}}]}},"name":"QuestionCategory","version":{"kind":"nothing"}}};

export const snQuestionCategory: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db", name:"QuestionCategory"};

export function texprQuestionCategory(): ADL.ATypeExpr<QuestionCategory> {
  return {value : {typeRef : {kind: "reference", value : snQuestionCategory}, parameters : []}};
}

export interface QuestionSubCategory_Information {
  kind: 'information';
}
export interface QuestionSubCategory_EmbeddedOffering {
  kind: 'embeddedOffering';
  value: common_db.DbKey<TrainingOffering>;
}

/**
 * Subcategories for intro/conclusion questions
 * 'info' => content comes from the question content itself
 * 'embedded' => content comes from the associated training offering
 */
export type QuestionSubCategory = QuestionSubCategory_Information | QuestionSubCategory_EmbeddedOffering;

const QuestionSubCategory_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"information","default":{"kind":"nothing"},"name":"information","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"embeddedOffering","default":{"kind":"nothing"},"name":"embeddedOffering","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"TrainingOffering"}},"parameters":[]}]}}]}},"name":"QuestionSubCategory","version":{"kind":"nothing"}}};

export const snQuestionSubCategory: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db", name:"QuestionSubCategory"};

export function texprQuestionSubCategory(): ADL.ATypeExpr<QuestionSubCategory> {
  return {value : {typeRef : {kind: "reference", value : snQuestionSubCategory}, parameters : []}};
}

/**
 * A Question
 */
export interface Question {
  /**
   * Admin name for question
   */
  name: string;
  /**
   * A Question belongs to 1 Skill - A Skill has many Questions. 
   */
  skillId: (common_db.DbKey<Skill>|null);
  /**
   * Alternatively, the Quesiton may be a 'blank' and be for info/embedded offering
   * only, with no scoring effect, although an embedded offering will affect how the
   * quiz progresses as it looks for a completion event before allowing the user to continue. 
   */
  category: QuestionCategory;
  /**
   * Content of the asking of the question
   */
  content: I18nContent;
  /**
   * Ordered list of possible answers presented at the question - can be empty
   */
  answers: I18nContent[];
  /**
   * Scoring of possible answers / combinations of answers.
   */
  scoring: AnswerScores;
}

export function makeQuestion(
  input: {
    name: string,
    skillId: (common_db.DbKey<Skill>|null),
    category: QuestionCategory,
    content: I18nContent,
    answers: I18nContent[],
    scoring: AnswerScores,
  }
): Question {
  return {
    name: input.name,
    skillId: input.skillId,
    category: input.category,
    content: input.content,
    answers: input.answers,
    scoring: input.scoring,
  };
}

const Question_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"extraSql":["ALTER TABLE question ADD CONSTRAINT question_skill_id_chk CHECK ( (category ? 'skill' AND skill_id IS NOT NULL) OR (NOT (category ? 'skill') AND skill_id IS NULL) );","CREATE OR REPLACE FUNCTION is_valid_training_offering(VARCHAR) RETURNS TEXT AS $$ SELECT id FROM training_offering WHERE id = $1; $$ language SQL;","ALTER TABLE question ADD CONSTRAINT question_category_chk CHECK ((category ?| array['conclusion','introduction'] AND (is_valid_training_offering(category->'conclusion'->>'embeddedOffering') IS NOT NULL OR is_valid_training_offering(category->'introduction'->>'embeddedOffering') IS NOT NULL)) OR category ? 'skill' OR category->'introduction' ? 'information' OR category->'conclusion' ? 'information');"],"withIdPrimaryKey":true,"uniquenessConstraints":[["skillId","name"]]}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"name","default":{"kind":"nothing"},"name":"name","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"skillId","default":{"kind":"nothing"},"name":"skillId","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"Skill"}},"parameters":[]}]}]}},{"annotations":[],"serializedName":"category","default":{"kind":"nothing"},"name":"category","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"QuestionCategory"}},"parameters":[]}},{"annotations":[],"serializedName":"content","default":{"kind":"nothing"},"name":"content","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"I18nContent"}},"parameters":[]}},{"annotations":[],"serializedName":"answers","default":{"kind":"nothing"},"name":"answers","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"I18nContent"}},"parameters":[]}]}},{"annotations":[],"serializedName":"scoring","default":{"kind":"nothing"},"name":"scoring","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"AnswerScores"}},"parameters":[]}}]}},"name":"Question","version":{"kind":"nothing"}}};

export const snQuestion: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db", name:"Question"};

export function texprQuestion(): ADL.ATypeExpr<Question> {
  return {value : {typeRef : {kind: "reference", value : snQuestion}, parameters : []}};
}

export interface QuizQuestion {
  /**
   * A QuizQuestion belongs to 1 QuizSkill - A QuizSkill has many QuizQuestion.
   * This is nullable because an intro or conclusion 'question' is not associated with
   * any skill.
   */
  quizSkillId: (common_db.DbKey<QuizSkill>|null);
  /**
   * We need to link the Quiz, for intro and outro questions not linked to skills.
   */
  quizId: common_db.DbKey<Quiz>;
  /**
   * Ordering of this question within the quiz
   */
  ordering: number;
  /**
   * Cloned copy of the Question
   */
  question: Question;
}

export function makeQuizQuestion(
  input: {
    quizSkillId: (common_db.DbKey<QuizSkill>|null),
    quizId: common_db.DbKey<Quiz>,
    ordering: number,
    question: Question,
  }
): QuizQuestion {
  return {
    quizSkillId: input.quizSkillId,
    quizId: input.quizId,
    ordering: input.ordering,
    question: input.question,
  };
}

const QuizQuestion_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"quizSkillId","default":{"kind":"nothing"},"name":"quizSkillId","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"QuizSkill"}},"parameters":[]}]}]}},{"annotations":[],"serializedName":"quizId","default":{"kind":"nothing"},"name":"quizId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"Quiz"}},"parameters":[]}]}},{"annotations":[],"serializedName":"ordering","default":{"kind":"nothing"},"name":"ordering","typeExpr":{"typeRef":{"kind":"primitive","value":"Double"},"parameters":[]}},{"annotations":[],"serializedName":"question","default":{"kind":"nothing"},"name":"question","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"Question"}},"parameters":[]}}]}},"name":"QuizQuestion","version":{"kind":"nothing"}}};

export const snQuizQuestion: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db", name:"QuizQuestion"};

export function texprQuizQuestion(): ADL.ATypeExpr<QuizQuestion> {
  return {value : {typeRef : {kind: "reference", value : snQuizQuestion}, parameters : []}};
}

/**
 * A Competency - Group of Skills
 */
export interface Competency {
  /**
   * Display name - depending on location, may need to be abbreviated
   */
  name: I18nContent;
  /**
   * Full name
   */
  fullName: I18nContent;
  /**
   * Long description definition
   */
  definition: I18nContent;
  /**
   * Order of competencies
   */
  ordering: number;
}

export function makeCompetency(
  input: {
    name: I18nContent,
    fullName: I18nContent,
    definition: I18nContent,
    ordering: number,
  }
): Competency {
  return {
    name: input.name,
    fullName: input.fullName,
    definition: input.definition,
    ordering: input.ordering,
  };
}

const Competency_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"extraSql":["CREATE UNIQUE INDEX on competency ((name->'text'->>'en'));"],"withIdPrimaryKey":true,"uniquenessConstraints":[["name"]]}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"name","default":{"kind":"nothing"},"name":"name","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"I18nContent"}},"parameters":[]}},{"annotations":[],"serializedName":"fullName","default":{"kind":"nothing"},"name":"fullName","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"I18nContent"}},"parameters":[]}},{"annotations":[],"serializedName":"definition","default":{"kind":"nothing"},"name":"definition","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"I18nContent"}},"parameters":[]}},{"annotations":[],"serializedName":"ordering","default":{"kind":"nothing"},"name":"ordering","typeExpr":{"typeRef":{"kind":"primitive","value":"Double"},"parameters":[]}}]}},"name":"Competency","version":{"kind":"nothing"}}};

export const snCompetency: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db", name:"Competency"};

export function texprCompetency(): ADL.ATypeExpr<Competency> {
  return {value : {typeRef : {kind: "reference", value : snCompetency}, parameters : []}};
}

/**
 * A Skill.
 */
export interface Skill {
  /**
   * Short name / title
   */
  name: I18nContent;
  /**
   * Long description definition
   */
  definition: I18nContent;
  /**
   * A markdown formatted paragraph of tips to help users improve this skill
   */
  guidanceTips: I18nContent;
  /**
   * Ordering of skill in displays - (Within competency)
   */
  ordering: number;
  competencyId: common_db.DbKey<Competency>;
  /**
   * Set of image URLs used in guidanceTips markdown
   */
  imageUrls: string[];
}

export function makeSkill(
  input: {
    name: I18nContent,
    definition: I18nContent,
    guidanceTips: I18nContent,
    ordering: number,
    competencyId: common_db.DbKey<Competency>,
    imageUrls: string[],
  }
): Skill {
  return {
    name: input.name,
    definition: input.definition,
    guidanceTips: input.guidanceTips,
    ordering: input.ordering,
    competencyId: input.competencyId,
    imageUrls: input.imageUrls,
  };
}

const Skill_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"extraSql":["CREATE UNIQUE INDEX on skill (competency_id, ((name->'text'->>'en')));"],"withIdPrimaryKey":true}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"name","default":{"kind":"nothing"},"name":"name","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"I18nContent"}},"parameters":[]}},{"annotations":[],"serializedName":"definition","default":{"kind":"nothing"},"name":"definition","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"I18nContent"}},"parameters":[]}},{"annotations":[],"serializedName":"guidanceTips","default":{"kind":"nothing"},"name":"guidanceTips","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"I18nContent"}},"parameters":[]}},{"annotations":[],"serializedName":"ordering","default":{"kind":"nothing"},"name":"ordering","typeExpr":{"typeRef":{"kind":"primitive","value":"Double"},"parameters":[]}},{"annotations":[],"serializedName":"competencyId","default":{"kind":"nothing"},"name":"competencyId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"Competency"}},"parameters":[]}]}},{"annotations":[],"serializedName":"imageUrls","default":{"kind":"nothing"},"name":"imageUrls","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}}]}},"name":"Skill","version":{"kind":"nothing"}}};

export const snSkill: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db", name:"Skill"};

export function texprSkill(): ADL.ATypeExpr<Skill> {
  return {value : {typeRef : {kind: "reference", value : snSkill}, parameters : []}};
}

/**
 * A Skill cloned for a particular quiz
 */
export interface QuizSkill {
  /**
   * A QuizSkill belongs to 1 Quiz - A Quiz has many QuizSkill
   */
  quizId: common_db.DbKey<Quiz>;
  competencyId: common_db.DbKey<Competency>;
  /**
   * Cloned copy of the Skill
   */
  skillId: common_db.DbKey<Skill>;
  skill: Skill;
  /**
   * Expected level, cloned from WorkRoleSkill join table.
   */
  expected: Score;
  /**
   * Industry average, cloned from WorkRoleSkill join table
   */
  industryAverage: Score;
}

export function makeQuizSkill(
  input: {
    quizId: common_db.DbKey<Quiz>,
    competencyId: common_db.DbKey<Competency>,
    skillId: common_db.DbKey<Skill>,
    skill: Skill,
    expected: Score,
    industryAverage: Score,
  }
): QuizSkill {
  return {
    quizId: input.quizId,
    competencyId: input.competencyId,
    skillId: input.skillId,
    skill: input.skill,
    expected: input.expected,
    industryAverage: input.industryAverage,
  };
}

const QuizSkill_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"quizId","default":{"kind":"nothing"},"name":"quizId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"Quiz"}},"parameters":[]}]}},{"annotations":[],"serializedName":"competencyId","default":{"kind":"nothing"},"name":"competencyId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"Competency"}},"parameters":[]}]}},{"annotations":[],"serializedName":"skillId","default":{"kind":"nothing"},"name":"skillId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"Skill"}},"parameters":[]}]}},{"annotations":[],"serializedName":"skill","default":{"kind":"nothing"},"name":"skill","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"Skill"}},"parameters":[]}},{"annotations":[],"serializedName":"expected","default":{"kind":"nothing"},"name":"expected","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"Score"}},"parameters":[]}},{"annotations":[],"serializedName":"industryAverage","default":{"kind":"nothing"},"name":"industryAverage","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"Score"}},"parameters":[]}}]}},"name":"QuizSkill","version":{"kind":"nothing"}}};

export const snQuizSkill: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db", name:"QuizSkill"};

export function texprQuizSkill(): ADL.ATypeExpr<QuizSkill> {
  return {value : {typeRef : {kind: "reference", value : snQuizSkill}, parameters : []}};
}

/**
 * FF2-433 Enable different ranges in report (not just A/J/M and 33%)
 */
export interface ScoreRange {
  label: I18nContent;
  range: sys_types.Pair<Score, Score>;
}

export function makeScoreRange(
  input: {
    label: I18nContent,
    range: sys_types.Pair<Score, Score>,
  }
): ScoreRange {
  return {
    label: input.label,
    range: input.range,
  };
}

const ScoreRange_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"label","default":{"kind":"nothing"},"name":"label","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"I18nContent"}},"parameters":[]}},{"annotations":[],"serializedName":"range","default":{"kind":"nothing"},"name":"range","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"sys.types","name":"Pair"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"Score"}},"parameters":[]},{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"Score"}},"parameters":[]}]}}]}},"name":"ScoreRange","version":{"kind":"nothing"}}};

export const snScoreRange: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db", name:"ScoreRange"};

export function texprScoreRange(): ADL.ATypeExpr<ScoreRange> {
  return {value : {typeRef : {kind: "reference", value : snScoreRange}, parameters : []}};
}

export interface WorkRoleScoreRange {
  workRoleId: common_db.DbKey<WorkRole>;
  scoreRange: ScoreRange;
}

export function makeWorkRoleScoreRange(
  input: {
    workRoleId: common_db.DbKey<WorkRole>,
    scoreRange: ScoreRange,
  }
): WorkRoleScoreRange {
  return {
    workRoleId: input.workRoleId,
    scoreRange: input.scoreRange,
  };
}

const WorkRoleScoreRange_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"extraSql":["CREATE UNIQUE INDEX on work_role_score_range (work_role_id, (score_range->'label'->'text'->>'en'));"],"withIdPrimaryKey":true}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"workRoleId","default":{"kind":"nothing"},"name":"workRoleId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"WorkRole"}},"parameters":[]}]}},{"annotations":[],"serializedName":"scoreRange","default":{"kind":"nothing"},"name":"scoreRange","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"ScoreRange"}},"parameters":[]}}]}},"name":"WorkRoleScoreRange","version":{"kind":"nothing"}}};

export const snWorkRoleScoreRange: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db", name:"WorkRoleScoreRange"};

export function texprWorkRoleScoreRange(): ADL.ATypeExpr<WorkRoleScoreRange> {
  return {value : {typeRef : {kind: "reference", value : snWorkRoleScoreRange}, parameters : []}};
}

export interface Owner_Global {
  kind: 'global';
}
export interface Owner_AppClientId {
  kind: 'appClientId';
  value: common_db.DbKey<AppClient>;
}

/**
 * Client-specific vs Global Objects
 */
export type Owner = Owner_Global | Owner_AppClientId;

const Owner_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"global","default":{"kind":"nothing"},"name":"global","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"appClientId","default":{"kind":"nothing"},"name":"appClientId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"AppClient"}},"parameters":[]}]}}]}},"name":"Owner","version":{"kind":"nothing"}}};

export const snOwner: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db", name:"Owner"};

export function texprOwner(): ADL.ATypeExpr<Owner> {
  return {value : {typeRef : {kind: "reference", value : snOwner}, parameters : []}};
}

/**
 * A WorkRole
 */
export interface WorkRole {
  name: I18nContent;
  /**
   * Short name - for use in tight spaces
   */
  shortname: I18nContent;
  owner: Owner;
  recommendationMethod: RoleRecommendationMethod;
  recommendationProviders: common_db.DbKey<LearningProvider>[];
  useSkillGroupReport: boolean;
}

export function makeWorkRole(
  input: {
    name: I18nContent,
    shortname: I18nContent,
    owner: Owner,
    recommendationMethod: RoleRecommendationMethod,
    recommendationProviders: common_db.DbKey<LearningProvider>[],
    useSkillGroupReport: boolean,
  }
): WorkRole {
  return {
    name: input.name,
    shortname: input.shortname,
    owner: input.owner,
    recommendationMethod: input.recommendationMethod,
    recommendationProviders: input.recommendationProviders,
    useSkillGroupReport: input.useSkillGroupReport,
  };
}

const WorkRole_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"extraSql":["CREATE UNIQUE INDEX on work_role (owner, (name->'text'->>'en'));"],"withIdPrimaryKey":true}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"name","default":{"kind":"nothing"},"name":"name","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"I18nContent"}},"parameters":[]}},{"annotations":[],"serializedName":"shortname","default":{"kind":"nothing"},"name":"shortname","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"I18nContent"}},"parameters":[]}},{"annotations":[],"serializedName":"owner","default":{"kind":"nothing"},"name":"owner","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"Owner"}},"parameters":[]}},{"annotations":[],"serializedName":"recommendationMethod","default":{"kind":"nothing"},"name":"recommendationMethod","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"RoleRecommendationMethod"}},"parameters":[]}},{"annotations":[],"serializedName":"recommendationProviders","default":{"kind":"nothing"},"name":"recommendationProviders","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"LearningProvider"}},"parameters":[]}]}]}},{"annotations":[],"serializedName":"useSkillGroupReport","default":{"kind":"nothing"},"name":"useSkillGroupReport","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}}]}},"name":"WorkRole","version":{"kind":"nothing"}}};

export const snWorkRole: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db", name:"WorkRole"};

export function texprWorkRole(): ADL.ATypeExpr<WorkRole> {
  return {value : {typeRef : {kind: "reference", value : snWorkRole}, parameters : []}};
}

export enum RoleRecommendationMethod {
  relevance,
  roleRange,
}

const RoleRecommendationMethod_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"relevance","default":{"kind":"nothing"},"name":"relevance","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"roleRange","default":{"kind":"nothing"},"name":"roleRange","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"RoleRecommendationMethod","version":{"kind":"nothing"}}};

export const snRoleRecommendationMethod: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db", name:"RoleRecommendationMethod"};

export function texprRoleRecommendationMethod(): ADL.ATypeExpr<RoleRecommendationMethod> {
  return {value : {typeRef : {kind: "reference", value : snRoleRecommendationMethod}, parameters : []}};
}

/**
 * Join table of WorkRole many-to-many Skill.
 * A WorkRole has many skills
 * A Skill belongs to many WorkRole
 */
export interface WorkRoleSkill {
  workRoleId: common_db.DbKey<WorkRole>;
  skillId: common_db.DbKey<Skill>;
  /**
   * Desired score of this Skill in this WorkRole
   */
  expected: Score;
  /**
   * The current industry average for this skill, inserted directly as data
   */
  industryAverage: Score;
  skillGroupHeadings: sys_types.Set<string>;
}

export function makeWorkRoleSkill(
  input: {
    workRoleId: common_db.DbKey<WorkRole>,
    skillId: common_db.DbKey<Skill>,
    expected: Score,
    industryAverage: Score,
    skillGroupHeadings: sys_types.Set<string>,
  }
): WorkRoleSkill {
  return {
    workRoleId: input.workRoleId,
    skillId: input.skillId,
    expected: input.expected,
    industryAverage: input.industryAverage,
    skillGroupHeadings: input.skillGroupHeadings,
  };
}

const WorkRoleSkill_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true,"uniquenessConstraints":[["workRoleId","skillId"]]}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"workRoleId","default":{"kind":"nothing"},"name":"workRoleId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"WorkRole"}},"parameters":[]}]}},{"annotations":[],"serializedName":"skillId","default":{"kind":"nothing"},"name":"skillId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"Skill"}},"parameters":[]}]}},{"annotations":[],"serializedName":"expected","default":{"kind":"nothing"},"name":"expected","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"Score"}},"parameters":[]}},{"annotations":[],"serializedName":"industryAverage","default":{"kind":"nothing"},"name":"industryAverage","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"Score"}},"parameters":[]}},{"annotations":[],"serializedName":"skillGroupHeadings","default":{"kind":"nothing"},"name":"skillGroupHeadings","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"sys.types","name":"Set"}},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}}]}},"name":"WorkRoleSkill","version":{"kind":"nothing"}}};

export const snWorkRoleSkill: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db", name:"WorkRoleSkill"};

export function texprWorkRoleSkill(): ADL.ATypeExpr<WorkRoleSkill> {
  return {value : {typeRef : {kind: "reference", value : snWorkRoleSkill}, parameters : []}};
}

export enum CompetencyBarsSlideout {
  all,
  noSkills,
  none,
}

const CompetencyBarsSlideout_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"all","default":{"kind":"nothing"},"name":"all","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"noSkills","default":{"kind":"nothing"},"name":"noSkills","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"none","default":{"kind":"nothing"},"name":"none","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"CompetencyBarsSlideout","version":{"kind":"nothing"}}};

export const snCompetencyBarsSlideout: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db", name:"CompetencyBarsSlideout"};

export function texprCompetencyBarsSlideout(): ADL.ATypeExpr<CompetencyBarsSlideout> {
  return {value : {typeRef : {kind: "reference", value : snCompetencyBarsSlideout}, parameters : []}};
}

export enum QuizType {
  quiz,
  selfAssessment,
}

const QuizType_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"quiz","default":{"kind":"nothing"},"name":"quiz","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"selfAssessment","default":{"kind":"nothing"},"name":"selfAssessment","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"QuizType","version":{"kind":"nothing"}}};

export const snQuizType: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db", name:"QuizType"};

export function texprQuizType(): ADL.ATypeExpr<QuizType> {
  return {value : {typeRef : {kind: "reference", value : snQuizType}, parameters : []}};
}

/**
 * A Quiz
 * - A quiz has many UserQuiz
 * - Has a cloned copy of the WorkRole
 * - Has many QuizSkill and QuizQuestion
 */
export interface Quiz {
  title: I18nContent;
  imageUrl: string;
  /**
   * Link to WorkRole used to generate Quiz (and default in Role Filter list)
   */
  workRoleId: common_db.DbKey<WorkRole>;
  /**
   * Cloned copy of the workRole applicable.
   */
  workRole: WorkRole;
  /**
   * Are Guidance Tips available for this quiz?
   */
  guidanceAvailable: boolean;
  /**
   * Are the CompetencyBars slideouts enabled?
   */
  competencyBars: CompetencyBarsSlideout;
  /**
   * Are Recommendations available for this quiz?
   */
  recommendationsAvailable: boolean;
  /**
   * Enable/disable display of Industry Average data series
   */
  showIndustryAverage: boolean;
  /**
   * Enable/disable display of Expected data series
   */
  hideExpected: boolean;
  /**
   * Alternative names for other report labels
   */
  expectedLabel: (I18nContent|null);
  actualLabel: (I18nContent|null);
  groupLabel: (I18nContent|null);
  industryLabel: (I18nContent|null);
  /**
   * Lock access to Results
   */
  lockResults: boolean;
  quizType: QuizType;
}

export function makeQuiz(
  input: {
    title: I18nContent,
    imageUrl: string,
    workRoleId: common_db.DbKey<WorkRole>,
    workRole: WorkRole,
    guidanceAvailable: boolean,
    competencyBars: CompetencyBarsSlideout,
    recommendationsAvailable: boolean,
    showIndustryAverage: boolean,
    hideExpected: boolean,
    expectedLabel: (I18nContent|null),
    actualLabel: (I18nContent|null),
    groupLabel: (I18nContent|null),
    industryLabel: (I18nContent|null),
    lockResults: boolean,
    quizType: QuizType,
  }
): Quiz {
  return {
    title: input.title,
    imageUrl: input.imageUrl,
    workRoleId: input.workRoleId,
    workRole: input.workRole,
    guidanceAvailable: input.guidanceAvailable,
    competencyBars: input.competencyBars,
    recommendationsAvailable: input.recommendationsAvailable,
    showIndustryAverage: input.showIndustryAverage,
    hideExpected: input.hideExpected,
    expectedLabel: input.expectedLabel,
    actualLabel: input.actualLabel,
    groupLabel: input.groupLabel,
    industryLabel: input.industryLabel,
    lockResults: input.lockResults,
    quizType: input.quizType,
  };
}

const Quiz_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"extraSql":["CREATE UNIQUE INDEX on quiz ((title->'text'->>'en'));"],"withIdPrimaryKey":true}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"title","default":{"kind":"nothing"},"name":"title","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"I18nContent"}},"parameters":[]}},{"annotations":[],"serializedName":"imageUrl","default":{"kind":"nothing"},"name":"imageUrl","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"workRoleId","default":{"kind":"nothing"},"name":"workRoleId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"WorkRole"}},"parameters":[]}]}},{"annotations":[],"serializedName":"workRole","default":{"kind":"nothing"},"name":"workRole","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"WorkRole"}},"parameters":[]}},{"annotations":[],"serializedName":"guidanceAvailable","default":{"kind":"nothing"},"name":"guidanceAvailable","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[],"serializedName":"competencyBars","default":{"kind":"nothing"},"name":"competencyBars","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"CompetencyBarsSlideout"}},"parameters":[]}},{"annotations":[],"serializedName":"recommendationsAvailable","default":{"kind":"nothing"},"name":"recommendationsAvailable","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[],"serializedName":"showIndustryAverage","default":{"kind":"nothing"},"name":"showIndustryAverage","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[],"serializedName":"hideExpected","default":{"kind":"nothing"},"name":"hideExpected","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[],"serializedName":"expectedLabel","default":{"kind":"nothing"},"name":"expectedLabel","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"I18nContent"}},"parameters":[]}]}},{"annotations":[],"serializedName":"actualLabel","default":{"kind":"nothing"},"name":"actualLabel","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"I18nContent"}},"parameters":[]}]}},{"annotations":[],"serializedName":"groupLabel","default":{"kind":"nothing"},"name":"groupLabel","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"I18nContent"}},"parameters":[]}]}},{"annotations":[],"serializedName":"industryLabel","default":{"kind":"nothing"},"name":"industryLabel","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"I18nContent"}},"parameters":[]}]}},{"annotations":[],"serializedName":"lockResults","default":{"kind":"nothing"},"name":"lockResults","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[],"serializedName":"quizType","default":{"kind":"nothing"},"name":"quizType","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"QuizType"}},"parameters":[]}}]}},"name":"Quiz","version":{"kind":"nothing"}}};

export const snQuiz: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db", name:"Quiz"};

export function texprQuiz(): ADL.ATypeExpr<Quiz> {
  return {value : {typeRef : {kind: "reference", value : snQuiz}, parameters : []}};
}

/**
 * A User participating in a Quiz
 */
export interface UserQuiz {
  /**
   * AppUser has many UserQuiz - UserQuiz belongs to 1 user.
   */
  appUserId: common_db.DbKey<AppUser>;
  /**
   * A UserQuiz belongs to 1 Quiz. A Quiz has many UserQuiz (one for each participant)
   */
  quizId: common_db.DbKey<Quiz>;
  /**
   * Time from backend of first showing of the user quiz
   */
  startedAt: (common.Instant|null);
  /**
   * Time from backend of last answer submission
   */
  completedAt: (common.Instant|null);
  /**
   * Time expected to be completed
   */
  dueAt: (common.Instant|null);
}

export function makeUserQuiz(
  input: {
    appUserId: common_db.DbKey<AppUser>,
    quizId: common_db.DbKey<Quiz>,
    startedAt: (common.Instant|null),
    completedAt: (common.Instant|null),
    dueAt: (common.Instant|null),
  }
): UserQuiz {
  return {
    appUserId: input.appUserId,
    quizId: input.quizId,
    startedAt: input.startedAt,
    completedAt: input.completedAt,
    dueAt: input.dueAt,
  };
}

const UserQuiz_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"extraSql":["CREATE INDEX uq_user_completedat_idx ON user_quiz (app_user_id ASC, completed_at DESC);"],"withIdPrimaryKey":true}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"appUserId","default":{"kind":"nothing"},"name":"appUserId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"AppUser"}},"parameters":[]}]}},{"annotations":[],"serializedName":"quizId","default":{"kind":"nothing"},"name":"quizId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"Quiz"}},"parameters":[]}]}},{"annotations":[],"serializedName":"startedAt","default":{"kind":"nothing"},"name":"startedAt","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}]}},{"annotations":[],"serializedName":"completedAt","default":{"kind":"nothing"},"name":"completedAt","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}]}},{"annotations":[],"serializedName":"dueAt","default":{"kind":"nothing"},"name":"dueAt","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}]}}]}},"name":"UserQuiz","version":{"kind":"nothing"}}};

export const snUserQuiz: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db", name:"UserQuiz"};

export function texprUserQuiz(): ADL.ATypeExpr<UserQuiz> {
  return {value : {typeRef : {kind: "reference", value : snUserQuiz}, parameters : []}};
}

/**
 * Remind user of their UserQuiz at the given time
 */
export interface UserQuizReminder {
  /**
   * Of a given UserQuiz
   */
  userQuizId: common_db.DbKey<UserQuiz>;
  /**
   * Time at which to send the reminder
   */
  remindAt: common.Instant;
}

export function makeUserQuizReminder(
  input: {
    userQuizId: common_db.DbKey<UserQuiz>,
    remindAt: common.Instant,
  }
): UserQuizReminder {
  return {
    userQuizId: input.userQuizId,
    remindAt: input.remindAt,
  };
}

const UserQuizReminder_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true,"indexes":[["remindAt"]]}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"userQuizId","default":{"kind":"nothing"},"name":"userQuizId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"UserQuiz"}},"parameters":[]}]}},{"annotations":[],"serializedName":"remindAt","default":{"kind":"nothing"},"name":"remindAt","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}}]}},"name":"UserQuizReminder","version":{"kind":"nothing"}}};

export const snUserQuizReminder: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db", name:"UserQuizReminder"};

export function texprUserQuizReminder(): ADL.ATypeExpr<UserQuizReminder> {
  return {value : {typeRef : {kind: "reference", value : snUserQuizReminder}, parameters : []}};
}

/**
 * The response given to a QuizQuestion in a UserQuiz
 * Created on submission of final response to a question
 */
export interface UserQuizQuestionSubmission {
  /**
   * For a given UserQuiz
   */
  userQuizId: common_db.DbKey<UserQuiz>;
  /**
   * For a given QuizQuestion
   */
  quizQuestionId: common_db.DbKey<QuizQuestion>;
  /**
   * The response submitted
   */
  answerResponse: AnswerResponse;
  /**
   * The time when submitted (as received at backend)
   */
  timeSubmitted: common.Instant;
  /**
   * The score awarded
   */
  score: Score;
}

export function makeUserQuizQuestionSubmission(
  input: {
    userQuizId: common_db.DbKey<UserQuiz>,
    quizQuestionId: common_db.DbKey<QuizQuestion>,
    answerResponse: AnswerResponse,
    timeSubmitted: common.Instant,
    score: Score,
  }
): UserQuizQuestionSubmission {
  return {
    userQuizId: input.userQuizId,
    quizQuestionId: input.quizQuestionId,
    answerResponse: input.answerResponse,
    timeSubmitted: input.timeSubmitted,
    score: input.score,
  };
}

const UserQuizQuestionSubmission_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true,"uniquenessConstraints":[["userQuizId","quizQuestionId"]]}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"userQuizId","default":{"kind":"nothing"},"name":"userQuizId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"UserQuiz"}},"parameters":[]}]}},{"annotations":[],"serializedName":"quizQuestionId","default":{"kind":"nothing"},"name":"quizQuestionId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"QuizQuestion"}},"parameters":[]}]}},{"annotations":[],"serializedName":"answerResponse","default":{"kind":"nothing"},"name":"answerResponse","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"AnswerResponse"}},"parameters":[]}},{"annotations":[],"serializedName":"timeSubmitted","default":{"kind":"nothing"},"name":"timeSubmitted","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[],"serializedName":"score","default":{"kind":"nothing"},"name":"score","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"Score"}},"parameters":[]}}]}},"name":"UserQuizQuestionSubmission","version":{"kind":"nothing"}}};

export const snUserQuizQuestionSubmission: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db", name:"UserQuizQuestionSubmission"};

export function texprUserQuizQuestionSubmission(): ADL.ATypeExpr<UserQuizQuestionSubmission> {
  return {value : {typeRef : {kind: "reference", value : snUserQuizQuestionSubmission}, parameters : []}};
}

/**
 * Event log of activity on a question
 * Capturing live selection of answers - ie on each click through of an answer.
 */
export interface UserQuizQuestionEvent {
  /**
   * For a given UserQuiz
   */
  userQuizId: common_db.DbKey<UserQuiz>;
  /**
   * For a given QuizQuestion
   */
  quizQuestionId: common_db.DbKey<QuizQuestion>;
  /**
   * The time of the event (as received at backend)
   */
  eventTime: common.Instant;
  /**
   * data of the event
   */
  eventType: QuizQuestionEventType;
}

export function makeUserQuizQuestionEvent(
  input: {
    userQuizId: common_db.DbKey<UserQuiz>,
    quizQuestionId: common_db.DbKey<QuizQuestion>,
    eventTime: common.Instant,
    eventType: QuizQuestionEventType,
  }
): UserQuizQuestionEvent {
  return {
    userQuizId: input.userQuizId,
    quizQuestionId: input.quizQuestionId,
    eventTime: input.eventTime,
    eventType: input.eventType,
  };
}

const UserQuizQuestionEvent_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"userQuizId","default":{"kind":"nothing"},"name":"userQuizId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"UserQuiz"}},"parameters":[]}]}},{"annotations":[],"serializedName":"quizQuestionId","default":{"kind":"nothing"},"name":"quizQuestionId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"QuizQuestion"}},"parameters":[]}]}},{"annotations":[],"serializedName":"eventTime","default":{"kind":"nothing"},"name":"eventTime","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[],"serializedName":"eventType","default":{"kind":"nothing"},"name":"eventType","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"QuizQuestionEventType"}},"parameters":[]}}]}},"name":"UserQuizQuestionEvent","version":{"kind":"nothing"}}};

export const snUserQuizQuestionEvent: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db", name:"UserQuizQuestionEvent"};

export function texprUserQuizQuestionEvent(): ADL.ATypeExpr<UserQuizQuestionEvent> {
  return {value : {typeRef : {kind: "reference", value : snUserQuizQuestionEvent}, parameters : []}};
}

export interface QuizQuestionEventType_Shown {
  kind: 'shown';
}
export interface QuizQuestionEventType_AnswerSelected {
  kind: 'answerSelected';
  value: AnswerResponse;
}
export interface QuizQuestionEventType_Heartbeat {
  kind: 'heartbeat';
}
export interface QuizQuestionEventType_Submitted {
  kind: 'submitted';
}

export type QuizQuestionEventType = QuizQuestionEventType_Shown | QuizQuestionEventType_AnswerSelected | QuizQuestionEventType_Heartbeat | QuizQuestionEventType_Submitted;

const QuizQuestionEventType_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"shown","default":{"kind":"nothing"},"name":"shown","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"answerSelected","default":{"kind":"nothing"},"name":"answerSelected","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"AnswerResponse"}},"parameters":[]}},{"annotations":[],"serializedName":"heartbeat","default":{"kind":"nothing"},"name":"heartbeat","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"submitted","default":{"kind":"nothing"},"name":"submitted","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"QuizQuestionEventType","version":{"kind":"nothing"}}};

export const snQuizQuestionEventType: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db", name:"QuizQuestionEventType"};

export function texprQuizQuestionEventType(): ADL.ATypeExpr<QuizQuestionEventType> {
  return {value : {typeRef : {kind: "reference", value : snQuizQuestionEventType}, parameters : []}};
}

export enum TrainingOfferingCategory {
  elearning,
  face2face,
  virtual,
}

const TrainingOfferingCategory_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"elearning","default":{"kind":"nothing"},"name":"elearning","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"face2face","default":{"kind":"nothing"},"name":"face2face","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"virtual","default":{"kind":"nothing"},"name":"virtual","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"TrainingOfferingCategory","version":{"kind":"nothing"}}};

export const snTrainingOfferingCategory: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db", name:"TrainingOfferingCategory"};

export function texprTrainingOfferingCategory(): ADL.ATypeExpr<TrainingOfferingCategory> {
  return {value : {typeRef : {kind: "reference", value : snTrainingOfferingCategory}, parameters : []}};
}

/**
 * TrainingOffering Supplier - (LPs) TIA, FC, LIL, (LXPs) Edcast, Saba, MindTickle, Degreed etc
 */
export interface LearningProvider {
  name: string;
  /**
   * "Username" (= Scodle domain) for API
   */
  username: string;
  /**
   * Password
   */
  authKey: string;
  /**
   * API Endpoint
   */
  apiEndpoint: string;
  catalog: (LearningProviderApiCall|null);
}

export function makeLearningProvider(
  input: {
    name: string,
    username: string,
    authKey: string,
    apiEndpoint: string,
    catalog: (LearningProviderApiCall|null),
  }
): LearningProvider {
  return {
    name: input.name,
    username: input.username,
    authKey: input.authKey,
    apiEndpoint: input.apiEndpoint,
    catalog: input.catalog,
  };
}

const LearningProvider_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true,"uniquenessConstraints":[["name"]]}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"name","default":{"kind":"nothing"},"name":"name","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"username","default":{"kind":"nothing"},"name":"username","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"authKey","default":{"kind":"nothing"},"name":"authKey","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"apiEndpoint","default":{"kind":"nothing"},"name":"apiEndpoint","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"catalog","default":{"kind":"nothing"},"name":"catalog","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"LearningProviderApiCall"}},"parameters":[]}]}}]}},"name":"LearningProvider","version":{"kind":"nothing"}}};

export const snLearningProvider: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db", name:"LearningProvider"};

export function texprLearningProvider(): ADL.ATypeExpr<LearningProvider> {
  return {value : {typeRef : {kind: "reference", value : snLearningProvider}, parameters : []}};
}

export interface LearningProviderApiCall {
  /**
   * Type: GET/PUT/PATCH/POST etc
   */
  method: string;
  path: string;
}

export function makeLearningProviderApiCall(
  input: {
    method: string,
    path: string,
  }
): LearningProviderApiCall {
  return {
    method: input.method,
    path: input.path,
  };
}

const LearningProviderApiCall_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"method","default":{"kind":"nothing"},"name":"method","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"path","default":{"kind":"nothing"},"name":"path","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"LearningProviderApiCall","version":{"kind":"nothing"}}};

export const snLearningProviderApiCall: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db", name:"LearningProviderApiCall"};

export function texprLearningProviderApiCall(): ADL.ATypeExpr<LearningProviderApiCall> {
  return {value : {typeRef : {kind: "reference", value : snLearningProviderApiCall}, parameters : []}};
}

/**
 * The list of available learning offerings for a provider.
 */
export interface LearningProviderCatalogEntry {
  /**
   * This catalog pertains to a specific LP
   */
  providerId: common_db.DbKey<LearningProvider>;
  /**
   * Course ID or URN
   */
  courseId: string;
  /**
   * Name of course
   */
  name: string;
  /**
   * Display name where real estate is short
   */
  shortname: string;
  /**
   * Description of offering
   */
  description: string;
  /**
   * "start date" of course
   */
  startdate: (common.Instant|null);
}

export function makeLearningProviderCatalogEntry(
  input: {
    providerId: common_db.DbKey<LearningProvider>,
    courseId: string,
    name: string,
    shortname: string,
    description: string,
    startdate: (common.Instant|null),
  }
): LearningProviderCatalogEntry {
  return {
    providerId: input.providerId,
    courseId: input.courseId,
    name: input.name,
    shortname: input.shortname,
    description: input.description,
    startdate: input.startdate,
  };
}

const LearningProviderCatalogEntry_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true,"uniquenessConstraints":[["providerId","courseId"]]}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"providerId","default":{"kind":"nothing"},"name":"providerId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"LearningProvider"}},"parameters":[]}]}},{"annotations":[],"serializedName":"courseId","default":{"kind":"nothing"},"name":"courseId","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"name","default":{"kind":"nothing"},"name":"name","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"shortname","default":{"kind":"nothing"},"name":"shortname","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"description","default":{"kind":"nothing"},"name":"description","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"startdate","default":{"kind":"nothing"},"name":"startdate","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}]}}]}},"name":"LearningProviderCatalogEntry","version":{"kind":"nothing"}}};

export const snLearningProviderCatalogEntry: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db", name:"LearningProviderCatalogEntry"};

export function texprLearningProviderCatalogEntry(): ADL.ATypeExpr<LearningProviderCatalogEntry> {
  return {value : {typeRef : {kind: "reference", value : snLearningProviderCatalogEntry}, parameters : []}};
}

/**
 * A training course / video etc
 */
export interface TrainingOffering {
  title: string;
  description: string;
  /**
   * Duration - 2 hours, 2 days, 30 mins etc
   */
  duration: string;
  /**
   * Renamed from enrolUrl - to better reflect its actual purpose
   */
  executeUrl: string;
  /**
   * Renamed from imageUrl
   */
  tileUrl: string;
  /**
   * Set of image URLs used in description markdown
   */
  imageUrls: string[];
  category: TrainingOfferingCategory;
  providerId: common_db.DbKey<LearningProvider>;
  catalogEntryId: (common_db.DbKey<LearningProviderCatalogEntry>|null);
}

export function makeTrainingOffering(
  input: {
    title: string,
    description: string,
    duration: string,
    executeUrl: string,
    tileUrl: string,
    imageUrls: string[],
    category: TrainingOfferingCategory,
    providerId: common_db.DbKey<LearningProvider>,
    catalogEntryId: (common_db.DbKey<LearningProviderCatalogEntry>|null),
  }
): TrainingOffering {
  return {
    title: input.title,
    description: input.description,
    duration: input.duration,
    executeUrl: input.executeUrl,
    tileUrl: input.tileUrl,
    imageUrls: input.imageUrls,
    category: input.category,
    providerId: input.providerId,
    catalogEntryId: input.catalogEntryId,
  };
}

const TrainingOffering_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true,"uniquenessConstraints":[["executeUrl"]]}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"title","default":{"kind":"nothing"},"name":"title","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"description","default":{"kind":"nothing"},"name":"description","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"duration","default":{"kind":"nothing"},"name":"duration","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"executeUrl","default":{"kind":"nothing"},"name":"executeUrl","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"tileUrl","default":{"kind":"nothing"},"name":"tileUrl","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"imageUrls","default":{"kind":"nothing"},"name":"imageUrls","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"category","default":{"kind":"nothing"},"name":"category","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"TrainingOfferingCategory"}},"parameters":[]}},{"annotations":[],"serializedName":"providerId","default":{"kind":"nothing"},"name":"providerId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"LearningProvider"}},"parameters":[]}]}},{"annotations":[],"serializedName":"catalogEntryId","default":{"kind":"nothing"},"name":"catalogEntryId","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"LearningProviderCatalogEntry"}},"parameters":[]}]}]}}]}},"name":"TrainingOffering","version":{"kind":"nothing"}}};

export const snTrainingOffering: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db", name:"TrainingOffering"};

export function texprTrainingOffering(): ADL.ATypeExpr<TrainingOffering> {
  return {value : {typeRef : {kind: "reference", value : snTrainingOffering}, parameters : []}};
}

export interface RoleScore {
  workRoleId: common_db.DbKey<WorkRole>;
  /**
   * DbKey<Skill> or DbKey<Competency>
   */
  skillOrCompetency: string;
  score: Score;
}

export function makeRoleScore(
  input: {
    workRoleId: common_db.DbKey<WorkRole>,
    skillOrCompetency: string,
    score: Score,
  }
): RoleScore {
  return {
    workRoleId: input.workRoleId,
    skillOrCompetency: input.skillOrCompetency,
    score: input.score,
  };
}

const RoleScore_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"workRoleId","default":{"kind":"nothing"},"name":"workRoleId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"WorkRole"}},"parameters":[]}]}},{"annotations":[],"serializedName":"skillOrCompetency","default":{"kind":"nothing"},"name":"skillOrCompetency","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"score","default":{"kind":"nothing"},"name":"score","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"Score"}},"parameters":[]}}]}},"name":"RoleScore","version":{"kind":"nothing"}}};

export const snRoleScore: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db", name:"RoleScore"};

export function texprRoleScore(): ADL.ATypeExpr<RoleScore> {
  return {value : {typeRef : {kind: "reference", value : snRoleScore}, parameters : []}};
}

export interface RecommendationType_RoleScore {
  kind: 'roleScore';
  value: RoleScore;
}
export interface RecommendationType_Priority {
  kind: 'priority';
  value: number;
}

/**
 * Two different Recommendation types - priority or role/score 
 */
export type RecommendationType = RecommendationType_RoleScore | RecommendationType_Priority;

const RecommendationType_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"roleScore","default":{"kind":"nothing"},"name":"roleScore","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"RoleScore"}},"parameters":[]}},{"annotations":[],"serializedName":"priority","default":{"kind":"nothing"},"name":"priority","typeExpr":{"typeRef":{"kind":"primitive","value":"Double"},"parameters":[]}}]}},"name":"RecommendationType","version":{"kind":"nothing"}}};

export const snRecommendationType: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db", name:"RecommendationType"};

export function texprRecommendationType(): ADL.ATypeExpr<RecommendationType> {
  return {value : {typeRef : {kind: "reference", value : snRecommendationType}, parameters : []}};
}

/**
 * A (recommendation of) a training offering for a user
 */
export interface UserTrainingOffering {
  /**
   * AppUser has many UserTrainingOffering - UserTrainingOffering belongs to 1 AppUser.
   */
  appUserId: common_db.DbKey<AppUser>;
  /**
   * A TrainingOffering has many UserTrainingOffering - UserTrainingOffering belongs to 1 TrainingOffering.
   */
  trainingOfferingId: common_db.DbKey<TrainingOffering>;
  /**
   * Possibly null - resulting from a UserQuiz
   */
  userQuizId: (common_db.DbKey<UserQuiz>|null);
  /**
   * This is now either a role + score + range or a priority
   * Store this here because calculating recommendations for the role/skill/score method is 
   * heaps easier when recs are generated than at report time
   * Difference:| priority                   | role/skill/range
   *  ----------+----------------------------+-----------------------------
   *   create   | create only for            | create only for
   *            | specified skill where      | specified skill where 
   *            | relevance exists > 0       | score in range (?all roles)
   *  ----------+----------------------------+-----------------------------
   *   report   | user: fetch only;          | user: fetch only;
   *            | group: calculate aggregate | group: ???
   */
  recommendation: RecommendationType;
}

export function makeUserTrainingOffering(
  input: {
    appUserId: common_db.DbKey<AppUser>,
    trainingOfferingId: common_db.DbKey<TrainingOffering>,
    userQuizId: (common_db.DbKey<UserQuiz>|null),
    recommendation: RecommendationType,
  }
): UserTrainingOffering {
  return {
    appUserId: input.appUserId,
    trainingOfferingId: input.trainingOfferingId,
    userQuizId: input.userQuizId,
    recommendation: input.recommendation,
  };
}

const UserTrainingOffering_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"appUserId","default":{"kind":"nothing"},"name":"appUserId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"AppUser"}},"parameters":[]}]}},{"annotations":[],"serializedName":"trainingOfferingId","default":{"kind":"nothing"},"name":"trainingOfferingId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"TrainingOffering"}},"parameters":[]}]}},{"annotations":[],"serializedName":"userQuizId","default":{"kind":"nothing"},"name":"userQuizId","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"UserQuiz"}},"parameters":[]}]}]}},{"annotations":[],"serializedName":"recommendation","default":{"kind":"nothing"},"name":"recommendation","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"RecommendationType"}},"parameters":[]}}]}},"name":"UserTrainingOffering","version":{"kind":"nothing"}}};

export const snUserTrainingOffering: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db", name:"UserTrainingOffering"};

export function texprUserTrainingOffering(): ADL.ATypeExpr<UserTrainingOffering> {
  return {value : {typeRef : {kind: "reference", value : snUserTrainingOffering}, parameters : []}};
}

/**
 * A table to help manage Reports available
 */
export interface Report {
  title: string;
  description: string;
  imageUrl: string;
  /**
   * API Request name
   */
  action: string;
  /**
   * SuperUser only, Client Admin, or everybody?
   */
  role: ApplicationRole;
}

export function makeReport(
  input: {
    title: string,
    description: string,
    imageUrl: string,
    action: string,
    role: ApplicationRole,
  }
): Report {
  return {
    title: input.title,
    description: input.description,
    imageUrl: input.imageUrl,
    action: input.action,
    role: input.role,
  };
}

const Report_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true,"uniquenessConstraints":[["title"],["action"]]}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"title","default":{"kind":"nothing"},"name":"title","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"description","default":{"kind":"nothing"},"name":"description","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"imageUrl","default":{"kind":"nothing"},"name":"imageUrl","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"action","default":{"kind":"nothing"},"name":"action","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"role","default":{"kind":"nothing"},"name":"role","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"ApplicationRole"}},"parameters":[]}}]}},"name":"Report","version":{"kind":"nothing"}}};

export const snReport: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db", name:"Report"};

export function texprReport(): ADL.ATypeExpr<Report> {
  return {value : {typeRef : {kind: "reference", value : snReport}, parameters : []}};
}

export interface RecommendationMethod_RoleRange {
  kind: 'roleRange';
  value: common_db.DbKey<WorkRoleScoreRange>;
}
export interface RecommendationMethod_Relevance {
  kind: 'relevance';
  value: number;
}

/**
 * Two different methods of generating Recommendations - priority listing
 * or score within range for role
 * Range is stored on role
 */
export type RecommendationMethod = RecommendationMethod_RoleRange | RecommendationMethod_Relevance;

const RecommendationMethod_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"roleRange","default":{"kind":"nothing"},"name":"roleRange","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"WorkRoleScoreRange"}},"parameters":[]}]}},{"annotations":[],"serializedName":"relevance","default":{"kind":"nothing"},"name":"relevance","typeExpr":{"typeRef":{"kind":"primitive","value":"Double"},"parameters":[]}}]}},"name":"RecommendationMethod","version":{"kind":"nothing"}}};

export const snRecommendationMethod: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db", name:"RecommendationMethod"};

export function texprRecommendationMethod(): ADL.ATypeExpr<RecommendationMethod> {
  return {value : {typeRef : {kind: "reference", value : snRecommendationMethod}, parameters : []}};
}

/**
 * A table representing how relevant training offerings are to skills, OR
 * what workrole/range it associates with for that COMPETENCY
 */
export interface SkillTrainingOffering {
  skillId: common_db.DbKey<Skill>;
  trainingOfferingId: common_db.DbKey<TrainingOffering>;
  method: RecommendationMethod;
}

export function makeSkillTrainingOffering(
  input: {
    skillId: common_db.DbKey<Skill>,
    trainingOfferingId: common_db.DbKey<TrainingOffering>,
    method: RecommendationMethod,
  }
): SkillTrainingOffering {
  return {
    skillId: input.skillId,
    trainingOfferingId: input.trainingOfferingId,
    method: input.method,
  };
}

const SkillTrainingOffering_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"extraSql":["CREATE UNIQUE INDEX skill_training_offering_1_uix ON skill_training_offering (skill_id,training_offering_id) WHERE (method ? 'relevance');","CREATE UNIQUE INDEX skill_training_offering_2_uix ON skill_training_offering (skill_id,training_offering_id,(method->>'roleRange')) WHERE (method ? 'roleRange');"],"withIdPrimaryKey":true}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"skillId","default":{"kind":"nothing"},"name":"skillId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"Skill"}},"parameters":[]}]}},{"annotations":[],"serializedName":"trainingOfferingId","default":{"kind":"nothing"},"name":"trainingOfferingId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"TrainingOffering"}},"parameters":[]}]}},{"annotations":[],"serializedName":"method","default":{"kind":"nothing"},"name":"method","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"RecommendationMethod"}},"parameters":[]}}]}},"name":"SkillTrainingOffering","version":{"kind":"nothing"}}};

export const snSkillTrainingOffering: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db", name:"SkillTrainingOffering"};

export function texprSkillTrainingOffering(): ADL.ATypeExpr<SkillTrainingOffering> {
  return {value : {typeRef : {kind: "reference", value : snSkillTrainingOffering}, parameters : []}};
}

export interface CompetencyTrainingOffering {
  competencyId: common_db.DbKey<Competency>;
  trainingOfferingId: common_db.DbKey<TrainingOffering>;
  method: RecommendationMethod;
}

export function makeCompetencyTrainingOffering(
  input: {
    competencyId: common_db.DbKey<Competency>,
    trainingOfferingId: common_db.DbKey<TrainingOffering>,
    method: RecommendationMethod,
  }
): CompetencyTrainingOffering {
  return {
    competencyId: input.competencyId,
    trainingOfferingId: input.trainingOfferingId,
    method: input.method,
  };
}

const CompetencyTrainingOffering_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"extraSql":["CREATE UNIQUE INDEX competency_training_offering_1_uix ON competency_training_offering (competency_id,training_offering_id) WHERE (method ? 'relevance');","CREATE UNIQUE INDEX competency_training_offering_2_uix ON competency_training_offering (competency_id,training_offering_id,(method->>'roleRange')) WHERE (method ? 'roleRange');"],"withIdPrimaryKey":true}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"competencyId","default":{"kind":"nothing"},"name":"competencyId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"Competency"}},"parameters":[]}]}},{"annotations":[],"serializedName":"trainingOfferingId","default":{"kind":"nothing"},"name":"trainingOfferingId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"TrainingOffering"}},"parameters":[]}]}},{"annotations":[],"serializedName":"method","default":{"kind":"nothing"},"name":"method","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"RecommendationMethod"}},"parameters":[]}}]}},"name":"CompetencyTrainingOffering","version":{"kind":"nothing"}}};

export const snCompetencyTrainingOffering: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db", name:"CompetencyTrainingOffering"};

export function texprCompetencyTrainingOffering(): ADL.ATypeExpr<CompetencyTrainingOffering> {
  return {value : {typeRef : {kind: "reference", value : snCompetencyTrainingOffering}, parameters : []}};
}

export interface CompetencySkillTrainingOfferingVariant_CompetencyTrainingOffering<C, _S> {
  kind: 'competencyTrainingOffering';
  value: C;
}
export interface CompetencySkillTrainingOfferingVariant_SkillTrainingOffering<_C, S> {
  kind: 'skillTrainingOffering';
  value: S;
}

export type CompetencySkillTrainingOfferingVariant<C, S> = CompetencySkillTrainingOfferingVariant_CompetencyTrainingOffering<C, S> | CompetencySkillTrainingOfferingVariant_SkillTrainingOffering<C, S>;

const CompetencySkillTrainingOfferingVariant_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":["C","S"],"fields":[{"annotations":[],"serializedName":"competencyTrainingOffering","default":{"kind":"nothing"},"name":"competencyTrainingOffering","typeExpr":{"typeRef":{"kind":"typeParam","value":"C"},"parameters":[]}},{"annotations":[],"serializedName":"skillTrainingOffering","default":{"kind":"nothing"},"name":"skillTrainingOffering","typeExpr":{"typeRef":{"kind":"typeParam","value":"S"},"parameters":[]}}]}},"name":"CompetencySkillTrainingOfferingVariant","version":{"kind":"nothing"}}};

export const snCompetencySkillTrainingOfferingVariant: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db", name:"CompetencySkillTrainingOfferingVariant"};

export function texprCompetencySkillTrainingOfferingVariant<C, S>(texprC : ADL.ATypeExpr<C>, texprS : ADL.ATypeExpr<S>): ADL.ATypeExpr<CompetencySkillTrainingOfferingVariant<C, S>> {
  return {value : {typeRef : {kind: "reference", value : {moduleName : "totalinteraction.futurefit.db",name : "CompetencySkillTrainingOfferingVariant"}}, parameters : [texprC.value, texprS.value]}};
}

export type CompetencySkillTrainingOffering = CompetencySkillTrainingOfferingVariant<CompetencyTrainingOffering, SkillTrainingOffering>;

const CompetencySkillTrainingOffering_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db","decl":{"annotations":[],"type_":{"kind":"type_","value":{"typeParams":[],"typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"CompetencySkillTrainingOfferingVariant"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"CompetencyTrainingOffering"}},"parameters":[]},{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"SkillTrainingOffering"}},"parameters":[]}]}}},"name":"CompetencySkillTrainingOffering","version":{"kind":"nothing"}}};

export const snCompetencySkillTrainingOffering: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db", name:"CompetencySkillTrainingOffering"};

export function texprCompetencySkillTrainingOffering(): ADL.ATypeExpr<CompetencySkillTrainingOffering> {
  return {value : {typeRef : {kind: "reference", value : snCompetencySkillTrainingOffering}, parameters : []}};
}

/**
 * ----- [ Benchmarking ] ---------------------------------------
 */
export interface Benchmark {
  appClientId: common_db.DbKey<AppClient>;
  /**
   * Arbitrary name of benchmark
   */
  name: string;
  /**
   * Iteration: 1 = baseline, 2 = first re-benchmark, etc.
   */
  number: number;
  /**
   * Earliest point in time that benchmark is applied
   */
  startDate: common.Instant;
  /**
   * Window of time before which any repeat of the same assessment
   * should not be considered a new benchmark (measured from the first assessment instant,
   * not the benchmark start date)
   */
  period: string;
}

export function makeBenchmark(
  input: {
    appClientId: common_db.DbKey<AppClient>,
    name: string,
    number: number,
    startDate: common.Instant,
    period: string,
  }
): Benchmark {
  return {
    appClientId: input.appClientId,
    name: input.name,
    number: input.number,
    startDate: input.startDate,
    period: input.period,
  };
}

const Benchmark_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true,"uniquenessConstraints":[["appClientId","name","number"]]}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"appClientId","default":{"kind":"nothing"},"name":"appClientId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"AppClient"}},"parameters":[]}]}},{"annotations":[],"serializedName":"name","default":{"kind":"nothing"},"name":"name","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"number","default":{"kind":"nothing"},"name":"number","typeExpr":{"typeRef":{"kind":"primitive","value":"Int64"},"parameters":[]}},{"annotations":[],"serializedName":"startDate","default":{"kind":"nothing"},"name":"startDate","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[],"serializedName":"period","default":{"kind":"nothing"},"name":"period","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"Benchmark","version":{"kind":"nothing"}}};

export const snBenchmark: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db", name:"Benchmark"};

export function texprBenchmark(): ADL.ATypeExpr<Benchmark> {
  return {value : {typeRef : {kind: "reference", value : snBenchmark}, parameters : []}};
}

export interface BenchmarkAssignment {
  benchmarkId: common_db.DbKey<Benchmark>;
  userQuizId: common_db.DbKey<UserQuiz>;
}

export function makeBenchmarkAssignment(
  input: {
    benchmarkId: common_db.DbKey<Benchmark>,
    userQuizId: common_db.DbKey<UserQuiz>,
  }
): BenchmarkAssignment {
  return {
    benchmarkId: input.benchmarkId,
    userQuizId: input.userQuizId,
  };
}

const BenchmarkAssignment_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"benchmarkId","default":{"kind":"nothing"},"name":"benchmarkId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"Benchmark"}},"parameters":[]}]}},{"annotations":[],"serializedName":"userQuizId","default":{"kind":"nothing"},"name":"userQuizId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"UserQuiz"}},"parameters":[]}]}}]}},"name":"BenchmarkAssignment","version":{"kind":"nothing"}}};

export const snBenchmarkAssignment: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db", name:"BenchmarkAssignment"};

export function texprBenchmarkAssignment(): ADL.ATypeExpr<BenchmarkAssignment> {
  return {value : {typeRef : {kind: "reference", value : snBenchmarkAssignment}, parameters : []}};
}

/**
 * Log table for launched training offerings
 */
export interface TrainingOfferingLaunchLog {
  /**
   * Time started
   */
  startTime: common.Instant;
  /**
   * Training Offering 
   */
  trainingOfferingId: common_db.DbKey<TrainingOffering>;
  /**
   * User
   */
  userId: common_db.DbKey<AppUser>;
}

export function makeTrainingOfferingLaunchLog(
  input: {
    startTime: common.Instant,
    trainingOfferingId: common_db.DbKey<TrainingOffering>,
    userId: common_db.DbKey<AppUser>,
  }
): TrainingOfferingLaunchLog {
  return {
    startTime: input.startTime,
    trainingOfferingId: input.trainingOfferingId,
    userId: input.userId,
  };
}

const TrainingOfferingLaunchLog_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"startTime","default":{"kind":"nothing"},"name":"startTime","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[],"serializedName":"trainingOfferingId","default":{"kind":"nothing"},"name":"trainingOfferingId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"TrainingOffering"}},"parameters":[]}]}},{"annotations":[],"serializedName":"userId","default":{"kind":"nothing"},"name":"userId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"AppUser"}},"parameters":[]}]}}]}},"name":"TrainingOfferingLaunchLog","version":{"kind":"nothing"}}};

export const snTrainingOfferingLaunchLog: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db", name:"TrainingOfferingLaunchLog"};

export function texprTrainingOfferingLaunchLog(): ADL.ATypeExpr<TrainingOfferingLaunchLog> {
  return {value : {typeRef : {kind: "reference", value : snTrainingOfferingLaunchLog}, parameters : []}};
}

/**
 * ----- [ User Upload staging area ] ----------------------------------------
 * Got to be affixed to a client
 * Set a default language for language dependent data
 * Otherwise, define the fields as loosely as possible. Do the interpretations
 * in code
 * ---------------------------------------------------------------------------
 */
export interface UserUploadSet {
  /**
   * Client
   */
  clientId: common_db.DbKey<AppClient>;
  /**
   * Filename (opt)
   */
  filename: (string|null);
  /**
   * Time started
   */
  startTime: common.Instant;
  /**
   * Time ended
   */
  endTime: (common.Instant|null);
  /**
   * Overall state
   */
  state: UploadState;
}

export function makeUserUploadSet(
  input: {
    clientId: common_db.DbKey<AppClient>,
    filename: (string|null),
    startTime: common.Instant,
    endTime: (common.Instant|null),
    state: UploadState,
  }
): UserUploadSet {
  return {
    clientId: input.clientId,
    filename: input.filename,
    startTime: input.startTime,
    endTime: input.endTime,
    state: input.state,
  };
}

const UserUploadSet_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"clientId","default":{"kind":"nothing"},"name":"clientId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"AppClient"}},"parameters":[]}]}},{"annotations":[],"serializedName":"filename","default":{"kind":"nothing"},"name":"filename","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"startTime","default":{"kind":"nothing"},"name":"startTime","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[],"serializedName":"endTime","default":{"kind":"nothing"},"name":"endTime","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}]}},{"annotations":[],"serializedName":"state","default":{"kind":"nothing"},"name":"state","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"UploadState"}},"parameters":[]}}]}},"name":"UserUploadSet","version":{"kind":"nothing"}}};

export const snUserUploadSet: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db", name:"UserUploadSet"};

export function texprUserUploadSet(): ADL.ATypeExpr<UserUploadSet> {
  return {value : {typeRef : {kind: "reference", value : snUserUploadSet}, parameters : []}};
}

export interface UserUploadFields {
  LASTNAME: string;
  FIRSTNAME: string;
  EMAIL: string;
  MANAGER_NAME: string;
  MANAGER_EMAIL: string;
  ASSESSMENT_1: string;
  ASSESSMENT_2: string;
  ASSESSMENT_3: string;
  USERGROUP_1: string;
  USERGROUP_2: string;
  USERGROUP_3: string;
  USERGROUP_4: string;
  USERGROUP_5: string;
}

export function makeUserUploadFields(
  input: {
    LASTNAME?: string,
    FIRSTNAME?: string,
    EMAIL?: string,
    MANAGER_NAME?: string,
    MANAGER_EMAIL?: string,
    ASSESSMENT_1?: string,
    ASSESSMENT_2?: string,
    ASSESSMENT_3?: string,
    USERGROUP_1?: string,
    USERGROUP_2?: string,
    USERGROUP_3?: string,
    USERGROUP_4?: string,
    USERGROUP_5?: string,
  }
): UserUploadFields {
  return {
    LASTNAME: input.LASTNAME === undefined ? "lastName" : input.LASTNAME,
    FIRSTNAME: input.FIRSTNAME === undefined ? "firstName" : input.FIRSTNAME,
    EMAIL: input.EMAIL === undefined ? "email" : input.EMAIL,
    MANAGER_NAME: input.MANAGER_NAME === undefined ? "managerName" : input.MANAGER_NAME,
    MANAGER_EMAIL: input.MANAGER_EMAIL === undefined ? "managerEmail" : input.MANAGER_EMAIL,
    ASSESSMENT_1: input.ASSESSMENT_1 === undefined ? "assessment_1" : input.ASSESSMENT_1,
    ASSESSMENT_2: input.ASSESSMENT_2 === undefined ? "assessment_2" : input.ASSESSMENT_2,
    ASSESSMENT_3: input.ASSESSMENT_3 === undefined ? "assessment_3" : input.ASSESSMENT_3,
    USERGROUP_1: input.USERGROUP_1 === undefined ? "group_1" : input.USERGROUP_1,
    USERGROUP_2: input.USERGROUP_2 === undefined ? "group_2" : input.USERGROUP_2,
    USERGROUP_3: input.USERGROUP_3 === undefined ? "group_3" : input.USERGROUP_3,
    USERGROUP_4: input.USERGROUP_4 === undefined ? "group_4" : input.USERGROUP_4,
    USERGROUP_5: input.USERGROUP_5 === undefined ? "group_5" : input.USERGROUP_5,
  };
}

const UserUploadFields_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"LASTNAME","default":{"kind":"just","value":"lastName"},"name":"LASTNAME","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"FIRSTNAME","default":{"kind":"just","value":"firstName"},"name":"FIRSTNAME","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"EMAIL","default":{"kind":"just","value":"email"},"name":"EMAIL","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"MANAGER_NAME","default":{"kind":"just","value":"managerName"},"name":"MANAGER_NAME","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"MANAGER_EMAIL","default":{"kind":"just","value":"managerEmail"},"name":"MANAGER_EMAIL","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"ASSESSMENT_1","default":{"kind":"just","value":"assessment_1"},"name":"ASSESSMENT_1","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"ASSESSMENT_2","default":{"kind":"just","value":"assessment_2"},"name":"ASSESSMENT_2","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"ASSESSMENT_3","default":{"kind":"just","value":"assessment_3"},"name":"ASSESSMENT_3","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"USERGROUP_1","default":{"kind":"just","value":"group_1"},"name":"USERGROUP_1","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"USERGROUP_2","default":{"kind":"just","value":"group_2"},"name":"USERGROUP_2","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"USERGROUP_3","default":{"kind":"just","value":"group_3"},"name":"USERGROUP_3","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"USERGROUP_4","default":{"kind":"just","value":"group_4"},"name":"USERGROUP_4","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"USERGROUP_5","default":{"kind":"just","value":"group_5"},"name":"USERGROUP_5","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"UserUploadFields","version":{"kind":"nothing"}}};

export const snUserUploadFields: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db", name:"UserUploadFields"};

export function texprUserUploadFields(): ADL.ATypeExpr<UserUploadFields> {
  return {value : {typeRef : {kind: "reference", value : snUserUploadFields}, parameters : []}};
}

/**
 * CSV Format:
 * lastname,	firstname,	email,	manager_name,	manager_email,	assessment_1,	assessment_2,	assessment_3,	group_1,	group_2,	group_3,	group_4,	group_5
 */
export interface UserUploadRecord {
  uploadId: common_db.DbKey<UserUploadSet>;
  /**
   * Source data - strings
   * If we successfully match: Id
   */
  lastName: string;
  firstName: string;
  email: string;
  appUserId: (common_db.DbKey<AppUser>|null);
  managerName: string;
  managerEmail: string;
  managerGroupId: (common_db.DbKey<UserGroup>|null);
  memberId: (common_db.DbKey<UserGroupMember>|null);
  managerId: (common_db.DbKey<UserGroupManager>|null);
  managerAppUserId: (common_db.DbKey<AppUser>|null);
  /**
   * Up to 3 at the moment
   * 'En' because, at present, we don't support I18nContent in uploads
   */
  quizTitlesEn: string[];
  quizIds: common_db.DbKey<Quiz>[];
  userQuizIds: common_db.DbKey<UserQuiz>[];
  userGroupNames: string[];
  userGroupIds: common_db.DbKey<UserGroup>[];
  userGroupMemberIds: common_db.DbKey<UserGroupMember>[];
  state: UploadState[];
}

export function makeUserUploadRecord(
  input: {
    uploadId: common_db.DbKey<UserUploadSet>,
    lastName: string,
    firstName: string,
    email: string,
    appUserId: (common_db.DbKey<AppUser>|null),
    managerName: string,
    managerEmail: string,
    managerGroupId: (common_db.DbKey<UserGroup>|null),
    memberId: (common_db.DbKey<UserGroupMember>|null),
    managerId: (common_db.DbKey<UserGroupManager>|null),
    managerAppUserId: (common_db.DbKey<AppUser>|null),
    quizTitlesEn: string[],
    quizIds: common_db.DbKey<Quiz>[],
    userQuizIds: common_db.DbKey<UserQuiz>[],
    userGroupNames: string[],
    userGroupIds: common_db.DbKey<UserGroup>[],
    userGroupMemberIds: common_db.DbKey<UserGroupMember>[],
    state: UploadState[],
  }
): UserUploadRecord {
  return {
    uploadId: input.uploadId,
    lastName: input.lastName,
    firstName: input.firstName,
    email: input.email,
    appUserId: input.appUserId,
    managerName: input.managerName,
    managerEmail: input.managerEmail,
    managerGroupId: input.managerGroupId,
    memberId: input.memberId,
    managerId: input.managerId,
    managerAppUserId: input.managerAppUserId,
    quizTitlesEn: input.quizTitlesEn,
    quizIds: input.quizIds,
    userQuizIds: input.userQuizIds,
    userGroupNames: input.userGroupNames,
    userGroupIds: input.userGroupIds,
    userGroupMemberIds: input.userGroupMemberIds,
    state: input.state,
  };
}

const UserUploadRecord_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"uploadId","default":{"kind":"nothing"},"name":"uploadId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"UserUploadSet"}},"parameters":[]}]}},{"annotations":[],"serializedName":"lastName","default":{"kind":"nothing"},"name":"lastName","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"firstName","default":{"kind":"nothing"},"name":"firstName","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"email","default":{"kind":"nothing"},"name":"email","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"appUserId","default":{"kind":"nothing"},"name":"appUserId","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"AppUser"}},"parameters":[]}]}]}},{"annotations":[],"serializedName":"managerName","default":{"kind":"nothing"},"name":"managerName","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"managerEmail","default":{"kind":"nothing"},"name":"managerEmail","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"managerGroupId","default":{"kind":"nothing"},"name":"managerGroupId","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"UserGroup"}},"parameters":[]}]}]}},{"annotations":[],"serializedName":"memberId","default":{"kind":"nothing"},"name":"memberId","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"UserGroupMember"}},"parameters":[]}]}]}},{"annotations":[],"serializedName":"managerId","default":{"kind":"nothing"},"name":"managerId","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"UserGroupManager"}},"parameters":[]}]}]}},{"annotations":[],"serializedName":"managerAppUserId","default":{"kind":"nothing"},"name":"managerAppUserId","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"AppUser"}},"parameters":[]}]}]}},{"annotations":[],"serializedName":"quizTitlesEn","default":{"kind":"nothing"},"name":"quizTitlesEn","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"quizIds","default":{"kind":"nothing"},"name":"quizIds","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"Quiz"}},"parameters":[]}]}]}},{"annotations":[],"serializedName":"userQuizIds","default":{"kind":"nothing"},"name":"userQuizIds","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"UserQuiz"}},"parameters":[]}]}]}},{"annotations":[],"serializedName":"userGroupNames","default":{"kind":"nothing"},"name":"userGroupNames","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"userGroupIds","default":{"kind":"nothing"},"name":"userGroupIds","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"UserGroup"}},"parameters":[]}]}]}},{"annotations":[],"serializedName":"userGroupMemberIds","default":{"kind":"nothing"},"name":"userGroupMemberIds","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"UserGroupMember"}},"parameters":[]}]}]}},{"annotations":[],"serializedName":"state","default":{"kind":"nothing"},"name":"state","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"UploadState"}},"parameters":[]}]}}]}},"name":"UserUploadRecord","version":{"kind":"nothing"}}};

export const snUserUploadRecord: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db", name:"UserUploadRecord"};

export function texprUserUploadRecord(): ADL.ATypeExpr<UserUploadRecord> {
  return {value : {typeRef : {kind: "reference", value : snUserUploadRecord}, parameters : []}};
}

export interface UploadMessage {
  fieldName: string;
  message: string;
}

export function makeUploadMessage(
  input: {
    fieldName: string,
    message: string,
  }
): UploadMessage {
  return {
    fieldName: input.fieldName,
    message: input.message,
  };
}

const UploadMessage_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"fieldName","default":{"kind":"nothing"},"name":"fieldName","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"message","default":{"kind":"nothing"},"name":"message","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"UploadMessage","version":{"kind":"nothing"}}};

export const snUploadMessage: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db", name:"UploadMessage"};

export function texprUploadMessage(): ADL.ATypeExpr<UploadMessage> {
  return {value : {typeRef : {kind: "reference", value : snUploadMessage}, parameters : []}};
}

export interface UploadState_Error {
  kind: 'error';
  value: UploadMessage;
}
export interface UploadState_Warning {
  kind: 'warning';
  value: UploadMessage;
}
export interface UploadState_Ok {
  kind: 'ok';
  value: UploadMessage;
}
export interface UploadState_Loading {
  kind: 'loading';
}
export interface UploadState_Loaded {
  kind: 'loaded';
}

export type UploadState = UploadState_Error | UploadState_Warning | UploadState_Ok | UploadState_Loading | UploadState_Loaded;

const UploadState_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"error","default":{"kind":"nothing"},"name":"error","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"UploadMessage"}},"parameters":[]}},{"annotations":[],"serializedName":"warning","default":{"kind":"nothing"},"name":"warning","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"UploadMessage"}},"parameters":[]}},{"annotations":[],"serializedName":"ok","default":{"kind":"nothing"},"name":"ok","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"UploadMessage"}},"parameters":[]}},{"annotations":[],"serializedName":"loading","default":{"kind":"nothing"},"name":"loading","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"loaded","default":{"kind":"nothing"},"name":"loaded","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"UploadState","version":{"kind":"nothing"}}};

export const snUploadState: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db", name:"UploadState"};

export function texprUploadState(): ADL.ATypeExpr<UploadState> {
  return {value : {typeRef : {kind: "reference", value : snUploadState}, parameters : []}};
}

export const _AST_MAP: { [key: string]: ADL.ScopedDecl } = {
  "totalinteraction.futurefit.db.Triplet" : Triplet_AST,
  "totalinteraction.futurefit.db.BrandingUrl" : BrandingUrl_AST,
  "totalinteraction.futurefit.db.AppClient" : AppClient_AST,
  "totalinteraction.futurefit.db.AppClientId" : AppClientId_AST,
  "totalinteraction.futurefit.db.Auth0Tenant" : Auth0Tenant_AST,
  "totalinteraction.futurefit.db.Auth0SamlConnection" : Auth0SamlConnection_AST,
  "totalinteraction.futurefit.db.SamlNameidFormat" : SamlNameidFormat_AST,
  "totalinteraction.futurefit.db.LangCode" : LangCode_AST,
  "totalinteraction.futurefit.db.Internationalized" : Internationalized_AST,
  "totalinteraction.futurefit.db.I18nContent" : I18nContent_AST,
  "totalinteraction.futurefit.db.Lang" : Lang_AST,
  "totalinteraction.futurefit.db.Licence" : Licence_AST,
  "totalinteraction.futurefit.db.AppClientLicenceInactiveStatus" : AppClientLicenceInactiveStatus_AST,
  "totalinteraction.futurefit.db.AppClientLicenceActiveStatus" : AppClientLicenceActiveStatus_AST,
  "totalinteraction.futurefit.db.AppClientLicenceStatusType" : AppClientLicenceStatusType_AST,
  "totalinteraction.futurefit.db.AppClientLicenceStatus" : AppClientLicenceStatus_AST,
  "totalinteraction.futurefit.db.AppClientLicence" : AppClientLicence_AST,
  "totalinteraction.futurefit.db.AppUserSeat" : AppUserSeat_AST,
  "totalinteraction.futurefit.db.ApplicationRole" : ApplicationRole_AST,
  "totalinteraction.futurefit.db.AppUser" : AppUser_AST,
  "totalinteraction.futurefit.db.AppUserStatus" : AppUserStatus_AST,
  "totalinteraction.futurefit.db.UserGroup" : UserGroup_AST,
  "totalinteraction.futurefit.db.UserGroupMember" : UserGroupMember_AST,
  "totalinteraction.futurefit.db.UserGroupViewer" : UserGroupViewer_AST,
  "totalinteraction.futurefit.db.UserGroupManager" : UserGroupManager_AST,
  "totalinteraction.futurefit.db.AnswerIndex" : AnswerIndex_AST,
  "totalinteraction.futurefit.db.Score" : Score_AST,
  "totalinteraction.futurefit.db.AnswerVariant" : AnswerVariant_AST,
  "totalinteraction.futurefit.db.AnswerScores" : AnswerScores_AST,
  "totalinteraction.futurefit.db.SingleResponse" : SingleResponse_AST,
  "totalinteraction.futurefit.db.MultiResponse" : MultiResponse_AST,
  "totalinteraction.futurefit.db.OrderedResponse" : OrderedResponse_AST,
  "totalinteraction.futurefit.db.SelfAssessmentResponse" : SelfAssessmentResponse_AST,
  "totalinteraction.futurefit.db.AnswerResponse" : AnswerResponse_AST,
  "totalinteraction.futurefit.db.QuestionCategory" : QuestionCategory_AST,
  "totalinteraction.futurefit.db.QuestionSubCategory" : QuestionSubCategory_AST,
  "totalinteraction.futurefit.db.Question" : Question_AST,
  "totalinteraction.futurefit.db.QuizQuestion" : QuizQuestion_AST,
  "totalinteraction.futurefit.db.Competency" : Competency_AST,
  "totalinteraction.futurefit.db.Skill" : Skill_AST,
  "totalinteraction.futurefit.db.QuizSkill" : QuizSkill_AST,
  "totalinteraction.futurefit.db.ScoreRange" : ScoreRange_AST,
  "totalinteraction.futurefit.db.WorkRoleScoreRange" : WorkRoleScoreRange_AST,
  "totalinteraction.futurefit.db.Owner" : Owner_AST,
  "totalinteraction.futurefit.db.WorkRole" : WorkRole_AST,
  "totalinteraction.futurefit.db.RoleRecommendationMethod" : RoleRecommendationMethod_AST,
  "totalinteraction.futurefit.db.WorkRoleSkill" : WorkRoleSkill_AST,
  "totalinteraction.futurefit.db.CompetencyBarsSlideout" : CompetencyBarsSlideout_AST,
  "totalinteraction.futurefit.db.QuizType" : QuizType_AST,
  "totalinteraction.futurefit.db.Quiz" : Quiz_AST,
  "totalinteraction.futurefit.db.UserQuiz" : UserQuiz_AST,
  "totalinteraction.futurefit.db.UserQuizReminder" : UserQuizReminder_AST,
  "totalinteraction.futurefit.db.UserQuizQuestionSubmission" : UserQuizQuestionSubmission_AST,
  "totalinteraction.futurefit.db.UserQuizQuestionEvent" : UserQuizQuestionEvent_AST,
  "totalinteraction.futurefit.db.QuizQuestionEventType" : QuizQuestionEventType_AST,
  "totalinteraction.futurefit.db.TrainingOfferingCategory" : TrainingOfferingCategory_AST,
  "totalinteraction.futurefit.db.LearningProvider" : LearningProvider_AST,
  "totalinteraction.futurefit.db.LearningProviderApiCall" : LearningProviderApiCall_AST,
  "totalinteraction.futurefit.db.LearningProviderCatalogEntry" : LearningProviderCatalogEntry_AST,
  "totalinteraction.futurefit.db.TrainingOffering" : TrainingOffering_AST,
  "totalinteraction.futurefit.db.RoleScore" : RoleScore_AST,
  "totalinteraction.futurefit.db.RecommendationType" : RecommendationType_AST,
  "totalinteraction.futurefit.db.UserTrainingOffering" : UserTrainingOffering_AST,
  "totalinteraction.futurefit.db.Report" : Report_AST,
  "totalinteraction.futurefit.db.RecommendationMethod" : RecommendationMethod_AST,
  "totalinteraction.futurefit.db.SkillTrainingOffering" : SkillTrainingOffering_AST,
  "totalinteraction.futurefit.db.CompetencyTrainingOffering" : CompetencyTrainingOffering_AST,
  "totalinteraction.futurefit.db.CompetencySkillTrainingOfferingVariant" : CompetencySkillTrainingOfferingVariant_AST,
  "totalinteraction.futurefit.db.CompetencySkillTrainingOffering" : CompetencySkillTrainingOffering_AST,
  "totalinteraction.futurefit.db.Benchmark" : Benchmark_AST,
  "totalinteraction.futurefit.db.BenchmarkAssignment" : BenchmarkAssignment_AST,
  "totalinteraction.futurefit.db.TrainingOfferingLaunchLog" : TrainingOfferingLaunchLog_AST,
  "totalinteraction.futurefit.db.UserUploadSet" : UserUploadSet_AST,
  "totalinteraction.futurefit.db.UserUploadFields" : UserUploadFields_AST,
  "totalinteraction.futurefit.db.UserUploadRecord" : UserUploadRecord_AST,
  "totalinteraction.futurefit.db.UploadMessage" : UploadMessage_AST,
  "totalinteraction.futurefit.db.UploadState" : UploadState_AST
};



// WEBPACK FOOTER //
// ./src/adl-gen/totalinteraction/futurefit/db.ts